<template>              
  <VUEPopupWarning :Popup="PopupAvvisoData" :Richiesta="TestoPopupData" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiPopup="PopupAvvisoData = false" />
  <VUEModal v-if="PopupSelezioneAllineamento" :Titolo="this.GetTraduzioneLabel('Generic','TKN_SELEZ_DATA_ALL',this.LinguaUtente)" Altezza="180px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaAllineamento()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 5px">

        <div class="col-md-12" style="display: flex; justify-content: space-between;">        
          <button type="button" class="btn btn-info" style="font-weight:bold; width: 32%" @click="InserisciData(IntervalliTeporali.VentiquattroOre)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_24H',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-info" style="font-weight:bold; width: 32%" @click="InserisciData(IntervalliTeporali.UnaSettimana)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SETT',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-info" style="font-weight:bold; width: 32%" @click="InserisciData(IntervalliTeporali.UnMese)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MESE',this.LinguaUtente) }}</button>
        </div>

        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 30px">
          <p style="width: 22%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:32%" type="date" step="1" v-model="ObjAllineamento.DataAllineamento">     
          <div v-if="ObjAllineamento.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          <select v-if="ObjAllineamento.ListaOre.length > 0" class="form-control" style="float:left; width:18%;" v-model="ObjAllineamento.OrarioAllineamento">
            <option v-for="Ora in ObjAllineamento.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
          <div v-if="ObjAllineamento.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          <button v-if="ObjAllineamento.DataAllineamento != null" type="button" class="btn btn-info" style="font-weight:bold;width:24%;padding: 2px;font-size: 12px;" @click="TrovaCampioniPerData()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
          <div v-else style="width: 24%">&nbsp;</div>
        </div>
        <div v-if="Loading" style="margin-top: 10px;" :style="{'color' : Arancione}">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_RICERCA_IN_CORSO',this.LinguaUtente) }}...</p>
        </div>
        <div v-if="!ObjAllineamento.DatiTrovati && !Loading" style="margin-top: 10px; color: red">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_ALL_NON_TROVATO',this.LinguaUtente) }}</p>
        </div>         
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjAllineamento.DataAllineamento != null && ObjAllineamento.OrarioAllineamento != null && ObjAllineamento.DatiTrovati && ObjAllineamento.ListaOre.length > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupDimPlaceholder" :Titolo="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_MOD_DIM',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupDimPlaceholder()">
    <template v-slot:Body>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="float:left; width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_MOD_DIM_NUOVA',this.LinguaUtente) }}</p>
        <input class="form-control" style="float:left;width:40%" type="number" min="1" step="1" v-model="NewDimPlaceholder">
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupDimPlaceholder()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="NewDimPlaceholder > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupDimPlaceholder()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupSelezioneNuovaData" :Titolo="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_DATA_GRAF',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaAggiuntaGrafico()">
    <!-- <template v-slot:Body>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="float:left; width: 40%; margin: 0px">Scegli una data e un'ora</p>
        <input class="form-control" style="float:left; width:30%" type="date" step="1" v-model="NuovaDataGrafico">
        <select v-if="ListaOre.length > 0" class="form-control" style="float:left; width:20%; margin-left: 10px" v-model="NuovaOraGrafico">
          <option v-for="Ora in ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
        </select> 
      </div>
    </template> -->
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="width: 100px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_SEL_DATA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%" type="date" step="1" v-model="NuovaDataGrafico">     
          <button v-if="NuovaDataGrafico != null" type="button" class="btn btn-info" style="font-weight:bold;width:32%" @click="TrovaCampioniAbbinamentoPerData({}, OrdinaDate)">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_SEL_CERCA',this.LinguaUtente) }}</button>
          <div v-else style="width: 32%">&nbsp;</div>
        </div>
        <div v-if="ListaOre.length > 0" style="width: 100%; margin-top: 10px; display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center;">
          <select class="form-control" style="float:left; width:20%;" v-model="NuovaOraGrafico">
            <option v-for="Ora in ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
        </div>      
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaAggiuntaGrafico()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="NuovaDataGrafico != null && NuovaOraGrafico != null" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaNuovaDataAbbinato()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()" />

  <VUEModal v-if="PopupCatenaGenerale" :Titolo="TitoloPopupCatena" :Altezza="AltezzaPopupCatena + 'px'" Larghezza="1050px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaGenerale()" id="PopupDatiGeneraliCatena">
    <template v-slot:Body>
      <div style="margin-bottom: 40px; width: 100%;">
        <div class="form-control ZMPopupSelectionTab" :style="TabSelezionato == Tabs.Configurazione ? {'background-color' : ArancioneSfondo, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.Configurazione">{{Tabs.Configurazione}}</div>
        <div class="form-control ZMPopupSelectionTab" :style="TabSelezionato == Tabs.InfoCatena     ? {'background-color' : ArancioneSfondo, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.InfoCatena">{{Tabs.InfoCatena}}</div>
        <div class="form-control ZMPopupSelectionTab" :style="TabSelezionato == Tabs.Sensori        ? {'background-color' : ArancioneSfondo, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.Sensori">{{Tabs.Sensori}}</div>
        <div class="form-control ZMPopupSelectionTab" :style="TabSelezionato == Tabs.Piezometri     ? {'background-color' : ArancioneSfondo, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.Piezometri">{{Tabs.Piezometri}}</div>
      </div>
      
      <div v-if="TabSelezionato == Tabs.Configurazione">
        <div class="ZMNuovaRigaScheda" style="display:flex; justify-content: center;padding-top: 20px">
          <div class="ZMDivPopupContent" style="width: 49.5%">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_VERS',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div>
            <label class="form-control ZMLabelContentPopup" style="float: left; width: 49.5%; margin-bottom: 0px">{{CatenaSelezionata.DatiGenerali.VersioneElaborata}}</label>
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: 49.5%; justify-content: right">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_FUORI_SERVIZIO',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div>       
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="CatenaSelezionata.DatiGenerali.FUORI_SERVIZIO">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex">
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px)">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_IDENTIF',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="text" style="float: left; width: calc(100% - 20px - 150px)" v-model="CatenaSelezionata.DatiGenerali.IDENTIFICATIVO">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px)">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_DESCRIZIONE',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="text" style="float: left; width: calc(100% - 20px - 150px)" v-model="CatenaSelezionata.DatiGenerali.DESCRIZIONE">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda"  style="display:flex">
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px)">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_DATA_INST',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div>       
            <input class="form-control ZMInputData" type="date" style="float: left" v-model="CatenaSelezionata.DatiGenerali.DATA_INSTALLAZIONE">
          </div>
          <!-- <div class="ZMDivPopupContent" style="width: calc(50% + 25px)">
            <div style="width:10px;float:left">&nbsp;</div>       
            <input class="form-control ZMInputData" type="time" style="float: left" v-model="CatenaSelezionata.DatiGenerali.ORA_INSTALLAZIONE">
          </div> -->
          <div style="width:calc(50% + 45px);float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_DATA_CAL',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div>
            <input class="form-control ZMInputData" type="date" style="float: left" v-model="CatenaSelezionata.DatiGenerali.DATA_CALIBRAZIONE">
          </div> 
           <div class="ZMDivPopupContent" style="width: calc(50% - 10px)">
            <div style="width:10px;float:left">&nbsp;</div>       
            <input class="form-control ZMInputData" type="time" style="float: left" v-model="CatenaSelezionata.DatiGenerali.ORA_CALIBRAZIONE">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda"  style="display:flex">
          <div class="ZMDivPopupContent" style="justify-content: left">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 200px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_INTERP_M_LUNGHI',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div>       
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="CatenaSelezionata.DatiGenerali.INTERPOLAZIONE">
          </div>
        </div>        
        <div class="ZMSeparatoreScheda">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_STAZ_M',this.LinguaUtente) }}</div>
        <div class="ZMNuovaRigaScheda"  style="display:flex; justify-content: center">
          <div class="ZMDivPopupContent" style="width: calc(30% - 20px); justify-content: left">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_PLUV',this.LinguaUtente) }}</label>          
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="CatenaSelezionata.DatiGenerali.PLUVIOMETRO">
          </div>          
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(30% - 20px); justify-content: center">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_ANEM',this.LinguaUtente) }}</label>          
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="CatenaSelezionata.DatiGenerali.ANEMOMETRO">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(30% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TERMO',this.LinguaUtente) }}</label>          
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="CatenaSelezionata.DatiGenerali.TERMOMETRO">
          </div>
        </div>
        <div class="ZMSeparatoreScheda">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_SENSORI_ESTERNI',this.LinguaUtente) }}</div>
        <div class="ZMNuovaRigaScheda" style="display:flex; justify-content: center">
          <div class="ZMDivPopupContent" style="width: calc(40% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TENSIO',this.LinguaUtente) }}</label>          
            <input class="form-control ZMInputNumber" type="number" style="float: left" @input="CatenaSelezionata.DatiGenerali.NUMERO_TENSIOMETRI < 0 ? CatenaSelezionata.DatiGenerali.NUMERO_TENSIOMETRI = 0 : {}" v-model="CatenaSelezionata.DatiGenerali.NUMERO_TENSIOMETRI">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 10px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_MANO',this.LinguaUtente) }}</label>          
            <input class="form-control ZMInputNumber" type="number" style="float: left"  @input="CatenaSelezionata.DatiGenerali.NUMERO_MANOMETRI < 0 ? CatenaSelezionata.DatiGenerali.NUMERO_MANOMETRI = 0 : {}" v-model="CatenaSelezionata.DatiGenerali.NUMERO_MANOMETRI">
          </div>
        </div>
      </div>

      <div v-if="TabSelezionato == Tabs.InfoCatena">
        <div class="ZMNuovaRigaScheda" style="display:flex;padding-top: 20px">
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_CLIENTE',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="text" style="float: left; width: calc(100% - 20px - 150px)" v-model="CatenaSelezionata.DatiGenerali.CLIENTE">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_SITO',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="text" style="float: left; width: calc(100% - 20px - 150px)" v-model="CatenaSelezionata.DatiGenerali.SITO">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_MONIT',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="text" style="float: left; width: calc(100% - 20px - 150px)" v-model="CatenaSelezionata.DatiGenerali.MONITORAGGIO">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_PROG',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="text" style="float: left; width: calc(100% - 20px - 150px)" v-model="CatenaSelezionata.DatiGenerali.PROGETTO">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_INS_IMG',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input style="float: left; width: calc(40% - 20px - 150px)" title="ciao" type="file" id="InputImmagineMod" @change="LoadImmagineFromFile()" accept="image/*">
            <img v-if="CatenaSelezionata.DatiGenerali.IMMAGINE_CATENA" :src="CatenaSelezionata.DatiGenerali.IMMAGINE_CATENA" style="max-width: 100px;float: left;" />
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_NOTE',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div>     
            <textarea class="form-control" style=" width: calc(100% - 20px - 150px); resize:none; height: 100px;" v-model="CatenaSelezionata.DatiGenerali.NOTE"></textarea>
          </div>
        </div>
      </div>

      <div v-if="TabSelezionato == Tabs.Sensori">
        <label style="float: right; padding-right: 10px;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_N_SENS',this.LinguaUtente) + ': ' + CatenaSelezionata.DataTable.Righe.length }}</label>
        <img @click="AssignImpostaProfondita()" src="../../../src/assets/images/ImpostaProfondita.png" style="width:135px; margin-left: 10px; margin-bottom: 5px;">
          <VUEModal v-if="PopupImpostaProfondita" :Titolo="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_IMP_PROF',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
                    @onClickChiudiModal="AnnullaImpostaProfondita()">
            <template v-slot:Body>
              <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
                <p style="float:left; width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_INS_PROF',this.LinguaUtente) }}</p>
                <input class="form-control" style="float:left; width:30%" type="text" step="1" v-model="ProfonditaImpostata">
              </div>
            </template>
            <template v-slot:Footer>
              <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaImpostaProfondita()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
              <button v-if="ProfonditaImpostata != 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="AggiornaImpostaProfondita()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
            </template>
          </VUEModal>

        <img @click=AssignTipologiaModuli() src="../../../src/assets/images/TipologiaModuli.png" style="width:135px; margin-left: 80px; margin-bottom: 5px;">
          <VUEModal v-if="PopupTipologiaModuli" :Titolo="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_IMP_TIPO_MOD',this.LinguaUtente)" Altezza="230px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
                    @onClickChiudiModal="AnnullaTipologiaModuli()">
            <template v-slot:Body>
              <div class="form-row" style="font-size:14px; margin-top: 30px">
                <p style="align-content: center; width: 40%; margin-left: 30%; display: flex; align-content: center; justify-content: center; align-items: center;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TIPOLOGIE',this.LinguaUtente) }}</p>
                <div class="ZMNuovaRigaScheda" style="display:flex; display: flex; align-content: center; justify-content: center;">     
                  <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_INCL',this.LinguaUtente) }}</label>
                  <div style="width:20px;float:left">&nbsp;</div>  
                  <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ImpostaInclinometro">
                  <div style="width:100px;float:left">&nbsp;</div>
                  <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_EST',this.LinguaUtente) }}</label>
                  <div style="width:20px;float:left">&nbsp;</div>  
                  <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ImpostaEstensimetro">
                </div>
                <div class="ZMNuovaRigaScheda" style="display:flex; display: flex; align-content: center; justify-content: center;">  
                  <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_PIEZOMETRO',this.LinguaUtente) }}</label>
                  <div style="width:20px;float:left">&nbsp;</div>  
                  <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ImpostaPiezometro">
                  <div style="width:100px;float:left">&nbsp;</div>
                  <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TERMO',this.LinguaUtente) }}</label>
                  <div style="width:20px;float:left">&nbsp;</div>  
                  <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ImpostaTermometro">
                </div>
                <div class="ZMNuovaRigaScheda" style="display:flex; display: flex; align-content: center; justify-content: center;">  
                  <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_ACCEL',this.LinguaUtente) }}</label>
                  <div style="width:20px;float:left">&nbsp;</div>  
                  <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ImpostaAccelerometro">
                  <div style="width:100px;float:left">&nbsp;</div>
                  <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_MAGN',this.LinguaUtente) }}</label>
                  <div style="width:20px;float:left">&nbsp;</div>  
                  <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ImpostaMagnetometro">
                </div>
              </div>
            </template>
            <template v-slot:Footer>
              <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaTipologiaModuli()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
              <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="AggiornaTipologiaModuli()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
            </template>
          </VUEModal>
          <VUEDataTable :DataTable="CatenaSelezionata.DataTable" :AltezzaTabella="AltezzaDataTable + 'px'"/>
      </div>
        <div v-if="TabSelezionato == Tabs.Piezometri">
          <div style="display:flex; width: 100%;">
          <div class="ZMNuovaRigaScheda" style="display:flex;">
            <div class="ZMDivPopupContent" style="width: 100%">
              <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TIPO_GRAFICO',this.LinguaUtente) }}</label>
              <select class="form-control" style="float: left; width:100%" v-model="CatenaSelezionata.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO">
                <option v-for="Grafico in OpzioniGraficiPiezometri" :value="Grafico.Id" :key="Grafico.Id"> {{ Grafico.Descrizione }} </option>         
              </select>
            </div>
          </div>
          <div style="float:left; margin-right: 10%;">&nbsp;</div> 
          <div v-if="CatenaSelezionata.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO == 'S'" class="ZMNuovaRigaScheda" style="display:flex;">
            <div class="ZMDivPopupContent" style="width: 100%">
              <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_PIEZOMETRO',this.LinguaUtente) }}</label>
              <select class="form-control" style="float: left; width:100%;" 
                      v-model="CatenaSelezionata.DatiGenerali.PIEZOMETRO_DI_RIFERIMENTO" 
                      @change="ResetDefaultMostraIdPiezometri">
                <option :value="-1"> {{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_PIEZO_MEDIA',this.LinguaUtente) }} </option> 
                <option v-for="IdPiezometro in Piezometri" :value="IdPiezometro" :key="IdPiezometro"> {{ this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) }} {{ IdPiezometro }} </option> 
              </select>
            </div>
          </div>
          <div v-if="CatenaSelezionata.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO == 'P'" class="ZMNuovaRigaScheda" style="display:flex;width:40%">
          <div class="form-control" :style="TabSelezionatoPiezo == Tabs.ConfigurazionePiezo ? {'background-color' : ArancioneSfondo, 'color' : 'white'} : {}" @click="TabSelezionatoPiezo = Tabs.ConfigurazionePiezo">{{Tabs.ConfigurazionePiezo}}</div>
          <div class="form-control" :style="TabSelezionatoPiezo == Tabs.ConfigurazionePacker ? {'background-color' : ArancioneSfondo, 'color' : 'white'} : {}" @click="TabSelezionatoPiezo = Tabs.ConfigurazionePacker">{{Tabs.ConfigurazionePacker}}</div>
          </div>
        </div>
          
        <div v-if="CatenaSelezionata.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO == 'S' && CatenaSelezionata.DatiGenerali.PIEZOMETRO_DI_RIFERIMENTO == -1" class="ZMNuovaRigaScheda" style="float:left; margin-right: 10%;">
          <div class="ZMDivPopupContent">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width:auto">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_MOSTRA_MOD_MEDIA',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div>       
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="CatenaSelezionata.DatiGenerali.MOSTRA_ID_PIEZOMETRI">
          </div>
        </div> 

        <div v-if="CatenaSelezionata.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO == 'P' && TabSelezionatoPiezo == Tabs.ConfigurazionePiezo" class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 100%">
            <VUEDataTable :DataTable="CatenaSelezionata.DataTablePiezo" :AltezzaTabella="AltezzaDataTable + 'px'"/>
          </div>
        </div>
        <div v-if="CatenaSelezionata.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO == 'P' && TabSelezionatoPiezo == Tabs.ConfigurazionePacker" class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 100%">
            <VUEDataTable :DataTable="CatenaSelezionata.DataTablePacker" :AltezzaTabella="AltezzaDataTable + 'px'"/>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:Footer>  
      <label class="btn btn-info" type="button" style="cursor:pointer;font-weight:bold;width:25%; float: left">{{ this.GetTraduzioneLabel('Generic','TKN_CARICA_XML',this.LinguaUtente) }}
        <input style="display:none;" type="file" id="InputXML" @change="LoadXMLFile(elemento)" accept=".cew">
      </label> 
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaGenerale()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CatenaSelezionata.CanRecordGenerali()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaModificaGenerale()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEConfirm :Popup="PopupEliminazione"
              :Richiesta="TestoPopupEliminazione"
              :PathLogo="require('@/assets/images/LogoDMS.png')"
              :Programma="'DMSEW'"
              @onClickChiudiPopup="AnnullaEliminazione()"
              @onClickConfermaPopup="SegnaComeEliminato()" />

  <VUEPopupGraficaCatena v-if="PopupGraficaAllCatene"
                         :AltezzaPopup="AltezzaPopupCatena + 'px'"
                         :ObjGraficaCatena="ObjGrafica"
                         @OnClickConfermaPopup="ConfermaModificaGrafica()"
                         @OnClickChiudiPopup="AnnullaModificaGrafica()" />

  <VUEPopupColoriGraficaCatena  v-if="PopupGraficaColoriAllCatene"
                                :AltezzaPopup="200 + 'px'"
                                :ObjGraficaCatena="ObjGraficaColori"
                                @OnClickConfermaPopup="ConfermaModificaColoriGrafica()"
                                @OnClickChiudiPopup="AnnullaModificaColoriGrafica()" />

  <VUEModalCaricamentoDati v-if="CaricamentoDatiSiti"
                          :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"/>
  
  <VUEPopupDatiAssistenza :PopupDatiAssistenza="PopupDatiAssistenza"
                           @OnClickChiudiPopup="PopupDatiAssistenza = false" />

  <div v-if="ObjAllineamento.DataOraAllineamento" class="ZMOverCanvasAlign" :style="{'background-color' : SfondoAllineamento, 'pointer-events' : 'none'}">
    <label>{{ GetTraduzioneLabel('VUEComponenteGraficoGenerico', 'TKN_GRAF_GEN_MSG_ALL_DATA', LinguaUtente) + ':' }}</label>
    <label>{{ ObjAllineamento.DataOraAllineamento }}</label>
  </div>


  <div class="container" ref="CanvasContainer" :style="!Mobile ? {'min-width' : '1360px'} : {}" style="width:100%;height:100%; min-height: 450px; padding:0px; margin:0px; position: relative; top:0px; left: 0px;overflow: hidden!important">

    <VUEComponenteGraficoGenerico v-for="Catena in CateneMostrate"
                                  :key="Catena.DatiCatena.CHIAVE"
                                  style="pointer-events: none"
                                  @AdattaAltriGrafici="AdattaAltriGrafici"
                                  :CatenaInfo="Catena"
                                  :AltezzaPopup="AltezzaPopupCatena"
                                  :OnDashboard="true"
                                  :Contatore="Contatore"
                                  :MostraGrafici="MostraGrafici && !Catena.DatiCatena.CatenaSoloMeteo && !Catena.DatiCatena.CatenaSoloPiezo"
                                  :AllineamentoSelezionato="ObjAllineamento.DataOraAllineamento"
                                  :GraficiChange="GraficiChange"
                                  :Zoom="AdjZoom"
                                  :TipoGrafico="Polare"
                                  :Repaint="Repaint" />

    <div v-for="Placeholder in PlaceholderMostrati" :key="Placeholder.Chiave" style="position: absolute; display: flex; flex-direction: column; align-items: center; pointer-events: none;"
          :style="{'top': Placeholder.MouseInfoPlaceholder.Coordinates.y + 'px', 'left': Placeholder.MouseInfoPlaceholder.Coordinates.x + 'px'}" ref="Placeholder">      
      <div>
        <span v-html="GetSvg(Placeholder,Placeholder.Immagine != 'Pallino')"></span>
        <div v-if="(!MostraGrafici || Placeholder.CatenaSoloPiezo) && !SpostamentoAbilitato" :style="{'height' : Placeholder.MouseInfoPlaceholder.Detail.height + 'px', 'width' : Placeholder.MouseInfoPlaceholder.Detail.width + 'px', left: (Placeholder.Immagine != '' && Placeholder.Immagine != 'Pallino' ? 6 : 0) + 'px'}" style="position: absolute; bottom: 0px; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer;" @click="VaiAGraficiVerticali(Placeholder)">
          <a :title="this.GetTraduzioneLabel('Generic','TKN_IMP_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
        </div>
      </div>
    </div>
    
    <div v-for="Placeholder in PlaceholderMostrati" :key="Placeholder.Chiave" style="position: absolute; display: flex; flex-direction: column; align-items: center; pointer-events: none; width: 1000px;"
          :style="CalculateTitleContainerStyle(Placeholder)">   
      <div :style="CalculateTitleStyle(Placeholder)">{{ Placeholder.Descrizione }}</div>
      
      <!-- <div v-if="EnableAlarmInfo && Placeholder.Immagine != 'Pallino'" :style="{'margin-top' : Placeholder.MouseInfoPlaceholder.Detail.height + 'px'}">
        <div :style="CalculateTitleStyle(Placeholder)">{{ GetTraduzioneLabel('VUEComponenteGraficoGenerico', 'TKN_GRAF_PLACEHOLDER_ALARM_INFO', LinguaUtente)}}</div>
        <div :style="CalculateAlarmStringStyle(Placeholder)">{{ GetLastAllarmeString(Placeholder.Chiave) }}</div>
      </div> -->
    </div>
    
    <div v-for="Placeholder in PlaceholderMostrati" :key="Placeholder.Chiave" style="position: absolute; display: flex; flex-direction: column; align-items: center; pointer-events: none; width: 1000px;"
          :style="CalculateTitleContainerStyle(Placeholder, true)">         
      <div v-if="EnableAlarmInfo && Placeholder.Immagine != 'Pallino'" :style="{'margin-top' : 5 + 'px'}">
        <div :style="CalculateTitleStyle(Placeholder)">{{ GetTraduzioneLabel('VUEComponenteGraficoGenerico', 'TKN_GRAF_PLACEHOLDER_ALARM_INFO', LinguaUtente)}}</div>
        <div :style="CalculateAlarmStringStyle(Placeholder)">{{ GetLastAllarmeString(Placeholder.Chiave) }}</div>
      </div>
    </div>

    <canvas ref="Canvas" :style="ObjStyleCanvas" style="touch-action: none" height="100" width="100" @touchstart="OnTouchStart" @touchmove="OnTouchMove" @touchend="OnTouchEnd" @wheel="OnMouseWheel" @pointerdown="OnMouseDown" @pointerup="OnMouseUp"></canvas>

    <!-- <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasName"><label style="font-size: 30px; width:100%; text-align: right">{{SitoSelezionato.NOME}}</label></div> -->

    <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasButton" :title="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_SITO_PREC',this.LinguaUtente)" style="top: 45%; left: 0.5%" @click="CambiaSitoIndietro()"><a class="fa fa-chevron-left" style="color: inherit"></a></div>
    <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasButton" :title="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_SITO_SUCC',this.LinguaUtente)" style="top: 45%; right: 0.5%" @click="CambiaSitoAvanti()"><a class="fa fa-chevron-right" style="color: inherit"></a></div>

    <!-- <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasButton" :title="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_MENU_CATENE',this.LinguaUtente)" style="bottom: 2%; right: 0.5%" @click="ApriMenuCatene()"><a class="fa fa-gear" style="color: inherit; font-size: 30px"></a></div>
    <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasButton" :title="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_CERCA_SITO',this.LinguaUtente)" style="right: calc(0.5% + 60px); bottom: calc(2% + 60px)" @click="ApriSlideRicerca()"><a class="fa fa-search" style="color: inherit; font-size: 30px"></a></div>
    <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasButton" :title="ObjAllineamento.DataOraAllineamento != null ? this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_RIMUOVI_ALL',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_SELEZ_ALL',this.LinguaUtente)" style="right: 0.5%; bottom: calc(2% + 60px)" @click="ToggleDataAllineamento()"><a :class="ObjAllineamento.DataOraAllineamento != null ? 'fa fa-refresh' : 'fa fa-clock-o'" style="color: inherit; font-size: 30px"></a></div>    
    <div v-if="!SlideAperti && !CambioSitoInCorso && Admin" class="ZMOverCanvasButton" :title="SpostamentoAbilitato ? this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_DISAB_SPOST',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_ABIL_SPOST',this.LinguaUtente)" style="right: 0.5%; bottom: calc(2% + 120px)" @click="SpostamentoAbilitato = !SpostamentoAbilitato"><a :class="SpostamentoAbilitato ? 'fa fa-unlock' : 'fa fa-lock'" style="color: inherit; font-size: 30px"></a></div>    
    <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasButton" :title="MostraGrafici ? this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_NASC_GRAF',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_MOSTRA_GRAF',this.LinguaUtente)" style="right: calc(0.5% + 60px); bottom: 2%" @click="!IsSitoMostraSoloMeteo ? ToggleMostraGrafici() : null" ><a :class="MostraGrafici ? 'fa fa-eye' : 'fa fa-eye-slash'" style="color: inherit; font-size: 30px"></a></div>
    <div v-if="!SlideAperti && !CambioSitoInCorso && MostraGrafici" class="ZMOverCanvasButton" :title="this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TITOLO_GEST_GRAF_ABB',this.LinguaUtente)" style="right: calc(0.5%); bottom: calc(2% + 180px)" @click="ApriMenuGraficiAbbinati()"><a class="fa fa-pie-chart" style="color: inherit; font-size: 30px"></a></div>
    <div v-if="!SlideAperti && !CambioSitoInCorso" class="ZMOverCanvasButton" :title="this.GetTraduzioneLabel('VUEAppContentDashboard',EnableAlarmInfo ? 'TKN_APP_CON_DASH_TITOLO_INFO_LAST_ALARM_HIDE' : 'TKN_APP_CON_DASH_TITOLO_INFO_LAST_ALARM',this.LinguaUtente)" style="right: calc(0.5% + 60px); bottom: calc(2% + 120px)" @click="EnableAlarmInfo = !EnableAlarmInfo"><a class="fa fa-exclamation" style="color: inherit; font-size: 30px"></a></div> -->

    <div v-if="MenuCateneAperto && !CambioSitoInCorso" class="ZMOverCanvasMenu" :style="{'height' : AltezzaCanvas + 'px'}">
      <div class="ZMMenuIntestazione">
        <button class="btn btn-info" @click="MenuCateneAperto = false"><a class="fa fa-chevron-right" style="color: inherit"></a></button>
        <div v-if="Admin" style="float:right">
          <div>
            <button class="btn btn-info" style="margin-right: 10px" @click="ApriPopupCambiaColoriGrafici()">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_CAMBIA_COLORI_GRAFICI',this.LinguaUtente) }}</button>
            <button class="btn btn-info" style="margin-right: 10px" @click="ApriPopupModifica()">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_MOD_GRAF_TUTTE_CATENE',this.LinguaUtente) }}</button>
            <button class="btn btn-success" @click="AggiungiNuovaCatena()">{{ this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_ADD_CATENA',this.LinguaUtente) }}</button>
          </div>
          <!-- <div style="margin-top: 5px">
            <button v-if="Admin" class="btn btn-info" @click="ApriPopupDimPlaceholder()">Modifica dimensione segnaposto</button>
          </div> -->
        </div>
      </div>
      <div class="ZMMenuContent" style="padding-top: 5px">
        <div v-for="Catena in SitoSelezionato.DatiCatene" :key="Catena.CHIAVE" class="ZMMenuContentVoce" style="cursor: pointer" @click="VaiACatena(Catena)">
          <label style="width: 70%; float: left; display: flex; align-items: center; padding-left: 10px; margin-bottom: 0px; cursor: pointer">{{Catena.DatiCatena.DESCRIZIONE}}</label>
          <div style="width: 30%; float: left; display: flex; align-items: center; justify-content: flex-end; gap: 10px; padding-right: 10px" @click.stop>
            <div v-if="Admin" class="ZMMenuIconButton" @click="ApriPopupDatiGeneraliCatena(Catena.DatiCatena.CHIAVE, SitoSelezionato.CHIAVE)"><a class="fa fa-pencil" style="color: inherit; display: flex; justify-content: center; align-items:center"></a></div>
            <div v-if="Admin" class="ZMMenuIconButton ZMDanger" @click="ApriPopupEliminazione(Catena.DatiCatena)"><a class="fa fa-trash" style="color: inherit; display: flex; justify-content: center; align-items:center"></a></div>
            <div class="ZMMenuIconButton">
              <a :class="Catena.DatiCatena.FUORI_SERVIZIO ? 'fa fa-eye' : 'fa fa-eye-slash'" @click="DisattivaAttivaCatena(Catena.DatiCatena)" style="color: inherit; display: flex; justify-content: center; align-items:center"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="MenuGraficiAbbinatiAperto && !CambioSitoInCorso" class="ZMOverCanvasMenu" :style="{'height' : AltezzaCanvas + 'px'}">
      <div class="ZMMenuIntestazione">
        <button class="btn btn-info" @click="MenuGraficiAbbinatiAperto = false"><a class="fa fa-chevron-right" style="color: inherit"></a></button>
        <button class="btn btn-info" style="float:right" @click="AggiungiNuovoGrafico(7)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SETT',this.LinguaUtente) }}</button>
        <button class="btn btn-info" style="float:right; margin-right: 10px" @click="AggiungiNuovoGrafico(2)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_48H',this.LinguaUtente) }}</button>
        <button class="btn btn-info" style="float:right; margin-right: 10px" @click="AggiungiNuovoGrafico(1)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_24H',this.LinguaUtente) }}</button>
        <button class="btn btn-info" style="float:right; margin-right: 10px" @click="PopupSelezioneNuovaData = true">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
      </div>
      <!-- <div class="ZMMenuIntestazione">
        <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left; float: right" type="checkbox" v-model="MostraUltimoGrafico">  
        <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 200px; float: right" @change="ToggleMostraUltimoGrafico()">Mostra ultimo grafico</label>          
      </div> -->
      <div class="ZMMenuContent">
        <div v-for="Grafico in ListaGrafici" :key="Grafico.DATA" class="ZMMenuContentVoce" style="display: flex; flex-flow: row wrap; justify-content: space-between">
          <label style="width: 130px; margin: 0px; display: flex; align-items: center; padding-left: 10px">{{Grafico.Data}}</label>          
          <label class="ZMColorPickerDiv" style="width: 150px; height: 25px; margin: 0px; display: flex; align-items: center; margin-left: 10px" @click="CambiaColoreGrafico(Grafico)" :style="{'background-color' : Grafico.Colore}"></label>          
          <div style="width: 25px; height: 25px; float: right; display: flex; align-items: center; justify-content: flex-end; gap: 10px; padding-right: 10px">
            <div class="ZMMenuIconButton ZMDanger" @click="RimuoviGrafico(Grafico.Data)"><a class="fa fa-trash" style="color: inherit; display: flex; justify-content: center; align-items:center"></a></div>
          </div>
        </div>
      </div>
    </div>
    <div style="position:absolute; bottom:0; left:0; width:100%; display:flex; align-items:center;">
      <div style="flex-basis:75%; text-align:left; align-items:left;justify-content: start;">
        <VUELegalFooter :IsDashboard="true" :ColorText="ColorTextDashboard"/>
      </div>
      <div style="flex-basis:25%; text-align:right; position:relative; margin-bottom:10px; right:15px; z-index:10">
          <img src="@/assets/images/LogoCSG.png"
              alt="Logo"
              @click="PopupDatiAssistenza = true"
              style="height:40px; width:auto; cursor:pointer;" />
      </div>
   </div>
  </div>
</template>

<script>
import { COLORI_DEFAULT_GRAFICI, COLORI_PANTONE, DIM_PLACEHOLDER, IMMAGINE_SITO_DEFAULT, MAX_ZOOM, RUOLI, SFONDO, SystemInformation, TIPI_GRAFICI, TIPI_GRANDEZZE_ALLARME, TIPOLOGIA_ALLARME_TO_UI, TTools, LOCALSTORAGE, TInfoGraficiStorici, TIPOLOGIA_GRAFICI_STORICI } from '@/SystemInformation'
import { OPZIONI_GRAFICI_PIEZOMETRI, POSIZIONI_TEXT_PLACEHOLDER, INTERVALLI_DI_TEMPO } from '@/SystemInformation.js'
import ObjIconaAllarme from '@/assets/IconaAllarme.json'
import MixInsDoubleClickHandler from './MixInsDoubleClickHandler'
import VUEComponenteGraficoGenerico from '@/components/Slots/VUEComponenteGraficoGenerico.vue'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEConfirm from '@/utils/VUEConfirm.vue'
import VUEDataTable from '@/utils/VUEDataTable.vue'
import VUEModal from '@/utils/VUEModal.vue'
import VUEModalCaricamentoDati from '@/utils/VUEModalCaricamentoDati.vue'
import { TZDataTable, TZDTableColumnType } from '@/utils/ZDataTable'
import { TZDateFunct } from '@/utils/ZDateFunct'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import { TSchedaGenerica } from '@/utils/ZSchedaGenerica.js'
import VUEPopupGraficaCatena from '../../components/Popups/VUEPopupGraficaCatena.vue'
import VUEPopupColoriGraficaCatena from '../../components/Popups/VUEPopupColoriGraficaCatena'
import VUEPopupWarning from '../../components/Popups/VUEPopupWarning.vue'
import { TemporaryGlobals } from '@/TemporararyGlobal.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni';
import VUELegalFooter from '@/components/FrameComponentsMultiPurpose/VUELegalFooter.vue';
import VUEPopupDatiAssistenza from '@/components/Popups/VUEPopupDatiAssistenza.vue';

export class TCatena
{
  constructor(ChiaveCatena, ChiaveSito, Moduli, GetTraduzioneLabel, LinguaUtente, Piezometro = [], Packer = [])
  {
    this.Chiave             = ChiaveCatena
    this.ChiaveSito         = ChiaveSito
    this.Moduli             = Moduli
    this.Piezometro         = Piezometro
    this.Packer             = Packer
    this.GetTraduzioneLabel = GetTraduzioneLabel
    this.LinguaUtente       = LinguaUtente
    this.Clear()
  }

  Disponi(OnSuccess = undefined)
  {
    let Self = this
    SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
    SystemInformation.AdvQuerySiti.GetSQL('Catene', { DMSEWSito: this.ChiaveSito, Chiave : this.Chiave },
                                         function(Results)
                                         {
                                           let ArrayCatena = (SystemInformation.AdvQuerySiti.FindResults(Results,'SelectCatena'))
                                           if (ArrayCatena != undefined)
                                           {
                                             let ObjCatena = ArrayCatena[0]

                                             Self.DatiGenerali.DESCRIZIONE               = TSchedaGenerica.DisponiFromString(ObjCatena.DESCRIZIONE)
                                             Self.DatiGenerali.IDENTIFICATIVO            = TSchedaGenerica.DisponiFromString(ObjCatena.IDENTIFICATIVO)
                                             Self.DatiGenerali.SITO                      = TSchedaGenerica.DisponiFromString(ObjCatena.SITO)
                                             Self.DatiGenerali.MONITORAGGIO              = TSchedaGenerica.DisponiFromString(ObjCatena.MONITORAGGIO)
                                             Self.DatiGenerali.CLIENTE                   = TSchedaGenerica.DisponiFromString(ObjCatena.CLIENTE)
                                             Self.DatiGenerali.DATA_INSTALLAZIONE        = TSchedaGenerica.DisponiFromDate(ObjCatena.DATA_INSTALLAZIONE)
                                             Self.DatiGenerali.PROGETTO                  = TSchedaGenerica.DisponiFromString(ObjCatena.PROGETTO)
                                             Self.DatiGenerali.IMMAGINE_CATENA           = TSchedaGenerica.DisponiFromString(ObjCatena.IMMAGINE_CATENA)
                                             Self.DatiGenerali.NOTE                      = TSchedaGenerica.DisponiFromString(ObjCatena.NOTE)
                                             Self.DatiGenerali.DATA_CALIBRAZIONE         = TSchedaGenerica.DisponiFromDate(ObjCatena.DATA_CALIBRAZIONE)
                                             Self.DatiGenerali.INTERPOLAZIONE            = TSchedaGenerica.DisponiFromBoolean(ObjCatena.INTERPOLAZIONE)
                                             Self.DatiGenerali.FUORI_SERVIZIO            = TSchedaGenerica.DisponiFromBoolean(ObjCatena.FUORI_SERVIZIO)
                                             Self.DatiGenerali.PLUVIOMETRO               = TSchedaGenerica.DisponiFromBoolean(ObjCatena.PLUVIOMETRO)
                                             Self.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO   = TSchedaGenerica.DisponiFromString(ObjCatena.TIPO_GRAFICO_PIEZOMETRO)
                                             Self.DatiGenerali.PIEZOMETRO_DI_RIFERIMENTO = TSchedaGenerica.DisponiFromInteger(ObjCatena.PIEZOMETRO_DI_RIFERIMENTO)
                                             Self.DatiGenerali.MOSTRA_ID_PIEZOMETRI      = TSchedaGenerica.DisponiFromBoolean(ObjCatena.MOSTRA_ID_PIEZOMETRI)
                                             Self.DatiGenerali.ANEMOMETRO                = TSchedaGenerica.DisponiFromBoolean(ObjCatena.ANEMOMETRO)
                                             Self.DatiGenerali.TERMOMETRO                = TSchedaGenerica.DisponiFromBoolean(ObjCatena.TERMOMETRO)
                                             Self.DatiGenerali.VERSIONE                  = TSchedaGenerica.DisponiFromString(ObjCatena.VERSIONE)
                                             Self.DatiGenerali.VersioneElaborata         = Self.GetVersioneElaborata()
                                             Self.DatiGenerali.NUMERO_MANOMETRI          = TSchedaGenerica.DisponiFromInteger(ObjCatena.NUMERO_MANOMETRI)
                                             Self.DatiGenerali.NUMERO_TENSIOMETRI        = TSchedaGenerica.DisponiFromInteger(ObjCatena.NUMERO_TENSIOMETRI)
                                             Self.DatiGenerali.ORA_INSTALLAZIONE         = TSchedaGenerica.DisponiFromHour(ObjCatena.ORA_INSTALLAZIONE)
                                             Self.DatiGenerali.ORA_CALIBRAZIONE          = TSchedaGenerica.DisponiFromHour(ObjCatena.ORA_CALIBRAZIONE)
                                             if (OnSuccess != undefined)
                                               OnSuccess()
                                           }
                                           else SystemInformation.HandleError("Impossibile ottenere la catena");
                                         },
                                         function(HTTPError,SubHTTPError,Response)
                                         {
                                           SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                         },
                                         'SelectDettaglioCatena')
  }

  RegistraDatiGenerali(OnSuccess = undefined)
  {
    let Self = this
    let ObjQuery = { Operazioni : [] }
    let ObjCatena = { Query : 'Insert', Parametri: {} }
    ObjCatena.Parametri = {
                            DESCRIZIONE                : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.DESCRIZIONE),
                            IDENTIFICATIVO             : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.IDENTIFICATIVO),
                            VERSIONE                   : TSchedaGenerica.PrepareForRecordInteger(this.DatiGenerali.VERSIONE),
                            SITO                       : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.SITO),
                            MONITORAGGIO               : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.MONITORAGGIO),
                            CLIENTE                    : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.CLIENTE),
                            DATA_INSTALLAZIONE         : TSchedaGenerica.PrepareForRecordDate(this.DatiGenerali.DATA_INSTALLAZIONE),
                            ORA_INSTALLAZIONE          : TSchedaGenerica.PrepareForRecordHour(this.DatiGenerali.ORA_INSTALLAZIONE),
                            PROGETTO                   : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.PROGETTO),
                            IMMAGINE_CATENA            : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.IMMAGINE_CATENA),
                            NOTE                       : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.NOTE),
                            DATA_CALIBRAZIONE          : TSchedaGenerica.PrepareForRecordDate(this.DatiGenerali.DATA_CALIBRAZIONE),
                            ORA_CALIBRAZIONE           : TSchedaGenerica.PrepareForRecordHour(this.DatiGenerali.ORA_CALIBRAZIONE),
                            INTERPOLAZIONE             : TSchedaGenerica.PrepareForRecordBoolean(this.DatiGenerali.INTERPOLAZIONE),
                            FUORI_SERVIZIO             : TSchedaGenerica.PrepareForRecordBoolean(this.DatiGenerali.FUORI_SERVIZIO),
                            PLUVIOMETRO                : TSchedaGenerica.PrepareForRecordBoolean(this.DatiGenerali.PLUVIOMETRO),
                            TIPO_GRAFICO_PIEZOMETRO    : TSchedaGenerica.PrepareForRecordString(this.DatiGenerali.TIPO_GRAFICO_PIEZOMETRO),
                            PIEZOMETRO_DI_RIFERIMENTO  : TSchedaGenerica.PrepareForRecordInteger(this.DatiGenerali.PIEZOMETRO_DI_RIFERIMENTO),
                            MOSTRA_ID_PIEZOMETRI       : TSchedaGenerica.PrepareForRecordBoolean(this.DatiGenerali.MOSTRA_ID_PIEZOMETRI),
                            ANEMOMETRO                 : TSchedaGenerica.PrepareForRecordBoolean(this.DatiGenerali.ANEMOMETRO),
                            TERMOMETRO                 : TSchedaGenerica.PrepareForRecordBoolean(this.DatiGenerali.TERMOMETRO),
                            NUMERO_MANOMETRI           : TSchedaGenerica.PrepareForRecordInteger(this.DatiGenerali.NUMERO_MANOMETRI),
                            NUMERO_TENSIOMETRI         : TSchedaGenerica.PrepareForRecordInteger(this.DatiGenerali.NUMERO_TENSIOMETRI)
                          }
    if (this.Chiave != -1)
    {
      ObjCatena.Query = 'Update'
      ObjCatena.Parametri.CHIAVE = this.Chiave
    }
    else
    {
      let GraphStdConfig                             = SystemInformation.Configurazione

      ObjCatena.Parametri.GRAPH_TITLE_COLOR          = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_TitleColor)
      ObjCatena.Parametri.GRAPH_TITLE_FONT_SIZE      = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_TitleFontSize)
      ObjCatena.Parametri.GRAPH_BACKGROUND           = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_Background)
      ObjCatena.Parametri.GRAPH_COLOR                = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_Color)
      ObjCatena.Parametri.GRAPH_MARKUP               = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_Markup)
      ObjCatena.Parametri.GRAPH_MARKUP_WIDTH         = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_MarkupWidth)
      ObjCatena.Parametri.GRAPH_PEN_WIDTH            = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_PenWidth)
      ObjCatena.Parametri.GRAPH_DRAW_BORDERS         = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.GRAPH_DrawBorders)
      ObjCatena.Parametri.GRAPH_AXES_MAX             = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_AXES_Max)
      ObjCatena.Parametri.GRAPH_AXES_NOTCH_SIZE      = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_AXES_NotchDim)
      ObjCatena.Parametri.GRAPH_AXES_COLOR           = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_AXES_Color)
      ObjCatena.Parametri.GRAPH_AXES_PEN_WIDTH       = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_AXES_PenWidth)
      ObjCatena.Parametri.GRAPH_AXES_NOTCH_COLOR     = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_AXES_NotchColor)
      ObjCatena.Parametri.GRAPH_AXES_NOTCH_FONT_SIZE = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_AXES_NotchFontSize)
      ObjCatena.Parametri.GRAPH_AXES_NOTCH_PEN_WIDTH = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_AXES_NotchPenWidth)
      ObjCatena.Parametri.GRAPH_AXES_FONT_SIZE       = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_AXES_FontSize)
      ObjCatena.Parametri.GRAPH_AXES_FONT_COLOR      = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_AXES_FontColor)
      ObjCatena.Parametri.GRAPH_AXES_LABELS_USE_BOLD = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.GRAPH_AXES_LabelsUseBold)
      ObjCatena.Parametri.GRAPH_DRAW_LATERAL_LABELS  = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.GRAPH_DrawLateralLabels)
      ObjCatena.Parametri.GRAPH_DRAW_NOTCH_LABELS    = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.GRAPH_DrawNotchLabels)
      ObjCatena.Parametri.GRAPH_DRAW_TITLE_STROKE    = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.GRAPH_DrawTitleStroke)
      ObjCatena.Parametri.GRAPH_AUTO_SCALE           = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.GRAPH_AutoScale)
      ObjCatena.Parametri.GRAPH_COLOR_TITLE_STROKE   = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_ColorTitleStroke)
      ObjCatena.Parametri.GRAPH_PLACEHOLDER_DIM      = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.GRAPH_PlaceholderDim)
      ObjCatena.Parametri.PLACEHOLDER_TITLE_SIZE     = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.PLACEHOLDER_TitleSize)
      ObjCatena.Parametri.PLACEHOLDER_TITLE_COLOR    = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.PLACEHOLDER_TitleColor)
      ObjCatena.Parametri.PLACEHOLDER_TEXT_POSITION  = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.PLACEHOLDER_TextPosition)
      ObjCatena.Parametri.GRAPH_POS_X                = 0
      ObjCatena.Parametri.GRAPH_POS_Y                = TSchedaGenerica.PrepareForRecordDouble(0.9, 5)
      ObjCatena.Parametri.PLACEHOLDER_POS_X          = 0
      ObjCatena.Parametri.PLACEHOLDER_POS_Y          = TSchedaGenerica.PrepareForRecordDouble(0.9, 5)
      ObjCatena.Parametri.CFG_INCLINOMETRO           = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.CFG_Inclinometro)
      ObjCatena.Parametri.CFG_SGHEMBO                = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.CFG_Sghembo)
      ObjCatena.Parametri.CFG_PIEZOMETRO             = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.CFG_Piezometro)
      ObjCatena.Parametri.CFG_ESTENSIMETRO           = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.CFG_Estensimetro)
      ObjCatena.Parametri.CFG_TEMPERATURA            = TSchedaGenerica.PrepareForRecordBoolean(GraphStdConfig.CFG_Temperatura)
      ObjCatena.Parametri.CFG_ACCELEROMETRO          = TSchedaGenerica.PrepareForRecordInteger(GraphStdConfig.CFG_Accelerometro)
      ObjCatena.Parametri.PLACEHOLDER_ALARM_COLOR    = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.PLACEHOLDER_AlarmColor)
      ObjCatena.Parametri.PLACEHOLDER_ALARM_EMPTY_CL = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.PLACEHOLDER_EmptyAlarmColor)
    }
    ObjQuery.Operazioni.push(ObjCatena)
    let i = -1
    if (this.Chiave != -1)
      ObjQuery.Operazioni.push({Query: "DeleteAllModuli",Parametri: { CATENA: Self.Chiave }});
    if (this.Chiave != -1)
      ObjQuery.Operazioni.push({Query: "DeleteAllPiezometri",Parametri: { CATENA: Self.Chiave }});
    if (this.Chiave != -1)
      ObjQuery.Operazioni.push({Query: "DeleteAllPacker",Parametri: { CATENA: Self.Chiave }});
    this.DataTable.Righe.forEach(function (Riga)
                            { 
                              let Parametri = Self.DataTable.PrepareQueryParameters(Riga)  
                              Parametri.CATENA = Self.Chiave;
                              if (Self.Chiave == -1)
                                Parametri.CATENA = undefined   
                              if (!Riga.Eliminato)
                              {
                                i++
                                Parametri.MODULO = i
                                ObjQuery.Operazioni.push({Query: "InsertModulo", Parametri: Parametri})
                              }
                            });
    this.DataTablePiezo.Righe.forEach(function (Riga)
                            { 
                              let Parametri = Self.DataTablePiezo.PrepareQueryParameters(Riga)                                                       
                              Parametri.CATENA = Self.Chiave;
                              if (Self.Chiave == -1)
                                Parametri.CATENA = undefined   
                              if (!Riga.Eliminato)
                              {
                                i++
                                Parametri.MODULO = i
                                ObjQuery.Operazioni.push({Query: "UpdatePiezometro", Parametri: Parametri})
                              }
                            });
    this.DataTablePacker.Righe.forEach(function (Riga)
                            { 
                              let Parametri = Self.DataTablePacker.PrepareQueryParameters(Riga)                                                       
                              Parametri.CATENA = Self.Chiave;
                              if (Self.Chiave == -1)
                                Parametri.CATENA = undefined   
                              if (!Riga.Eliminato)
                              {
                                i++
                                Parametri.MODULO = i
                                if(Riga.Dati.CATENA == -1)
                                  ObjQuery.Operazioni.push({Query: "UpdatePacker", Parametri: Parametri,ResetKeys : [2]})
                                else ObjQuery.Operazioni.push({Query: "InsertPacker", Parametri: Parametri,ResetKeys : [2]})
                              }
                            });
    SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
    SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                      function()
                                                      {
                                                        if (OnSuccess != undefined)
                                                          OnSuccess()                                                        
                                                      },
                                                      function(HTTPError,SubHTTPError,Response)
                                                      {
                                                        SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                      },
                                                      false, {DMSEWSito: this.ChiaveSito})
  }

  CanRecordGenerali()
  {
    return this.DatiGenerali.DESCRIZIONE != '' &&
           //this.DatiGenerali.IDENTIFICATIVO != '' &&
           this.DataTable.AllDataOk()
  }

  GetVersioneElaborata()
  {
    let stringa = this.DatiGenerali.VERSIONE
    if (stringa != '')
      return stringa.slice(0,2) + '.' + stringa.slice(2,4) + '.' + stringa.slice(4,6)
  }

  Clear()
  {
    this.DatiGenerali = {
                          DESCRIZIONE                 : '',
                          IDENTIFICATIVO              : '',
                          SITO                        : '',
                          MONITORAGGIO                : '',
                          CLIENTE                     : '',
                          DATA_INSTALLAZIONE          : TZDateFunct.DateInHTMLInputFormat(new Date()),
                          PROGETTO                    : '',
                          IMMAGINE_CATENA             : '',
                          NOTE                        : '',
                          TIPO_GRAFICO_PIEZOMETRO     : 'S',
                          PIEZOMETRO_DI_RIFERIMENTO   : -1,
                          DATA_CALIBRAZIONE           : TZDateFunct.DateInHTMLInputFormat(new Date()),
                          INTERPOLAZIONE              : false,
                          FUORI_SERVIZIO              : false,
                          PLUVIOMETRO                 : false,
                          ANEMOMETRO                  : false,
                          TERMOMETRO                  : false,
                          MOSTRA_ID_PIEZOMETRI        : false,
                          VERSIONE                    : '',
                          NUMERO_TENSIOMETRI          : 0,
                          NUMERO_MANOMETRI            : 0,
                          ORA_INSTALLAZIONE           : '00:00:00',
                          ORA_CALIBRAZIONE            : '00:00:00'
                        }
    this.DatiGenerali.VersioneElaborata     = this.GetVersioneElaborata(),
    this.DataTable                          = new TZDataTable('CATENA')
    this.DataTable.Configurazione.Larghezza = '100%'
    this.DataTable.ClearColumns()
    // let Colonna = this.DataTable.AddColumn('ID',
    //                                         TZDTableColumnType.typInteger,
    //                                         'MODULO',
    //                                         '10%')
    // Colonna.Necessario       = false
    // Colonna.Disabilitato     = true
    // Colonna.DoppioniPermessi = false
    let Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_ID',this.LinguaUtente),
                                         TZDTableColumnType.typInteger, 
                                         '',
                                         '10px')
    Colonna.OnCalcoloValore = '$Index'
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_INCL',this.LinguaUtente),
                                        TZDTableColumnType.typBoolean,
                                        'INCLINOMETRO',
                                        '1%')
    Colonna.DefaultValue = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_ESTEN',this.LinguaUtente),
                                        TZDTableColumnType.typBoolean,
                                        'ESTENSIMETRO',
                                        '1%')
    Colonna.DefaultValue = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_ABBR_PIEZO',this.LinguaUtente),
                                        TZDTableColumnType.typBoolean,
                                        'PIEZOMETRO',
                                        '1%')
    Colonna.DefaultValue = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_TERM',this.LinguaUtente),
                                        TZDTableColumnType.typBoolean,
                                        'TERMOMETRO',
                                        '1%')
    Colonna.DefaultValue = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_ACC',this.LinguaUtente),
                                        TZDTableColumnType.typBoolean,
                                        'ACCELEROMETRO',
                                        '1%')
    Colonna.DefaultValue = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_MAGNE',this.LinguaUtente),
                                        TZDTableColumnType.typBoolean,
                                        'MAGNETOMETRO',
                                        '1%')
    Colonna.DefaultValue = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_P_TESTA',this.LinguaUtente),
                                        TZDTableColumnType.typCentesimi,
                                        'PROFONDITA_TESTA',
                                        '130px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_P_CODA',this.LinguaUtente),
                                        TZDTableColumnType.typCentesimi,
                                        'PROFONDITA_CODA',
                                        '130px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_LUNG_MOD',this.LinguaUtente),
                                        TZDTableColumnType.typCentesimi,
                                        'LUNGHEZZA_SPEZZONE',
                                        '138px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_ASSE_ROLL',this.LinguaUtente),
                                        TZDTableColumnType.typCentesimi,
                                        'ORIENTAMENTO',
                                        '138px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_INIZIO_SEG_DEF',this.LinguaUtente),
                                        TZDTableColumnType.typDecimi,
                                        'SEGMENTO_DEFORMAZIONE_A',
                                        '138px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_FINE_SEG_DEF',this.LinguaUtente),
                                        TZDTableColumnType.typDecimi,
                                        'SEGMENTO_DEFORMAZIONE_B',
                                        '138px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    Colonna = this.DataTable.AddColumn((this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_FILTRO_DRY',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIMETRI',this.LinguaUtente) + ']'),
                                        TZDTableColumnType.typInteger,
                                        'PRESSIONE_SECCO',
                                        '138px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    Colonna = this.DataTable.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_QUOTA_PIEZO',this.LinguaUtente),// + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'),
                                        TZDTableColumnType.typMillesimi,
                                        'QUOTA_PIEZOMETRO',
                                        '138px')
    Colonna.DefaultValue = 0
    Colonna.Necessario = false
    this.DataTable.AssignDati(this.Moduli)
    this.DataTablePiezo = new TZDataTable('CATENA')
    this.DataTablePiezo.Configurazione.Larghezza = '1016px'
    this.DataTablePiezo.TastoAggiungiVisibile    = false
    this.DataTablePiezo.EditRicercaVisibile      = false
    this.DataTablePiezo.ClearColumns()
    let ColonnaPiezo = this.DataTablePiezo.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_ID',this.LinguaUtente),
                                         TZDTableColumnType.typString, 
                                         'NUMERO_PIEZOMETRO',
                                         '28%')
    ColonnaPiezo.ReadOnly = true
    ColonnaPiezo = this.DataTablePiezo.AddColumn(this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente),
                                        TZDTableColumnType.typColor,
                                        'COLORE',
                                        '50%')
    ColonnaPiezo = this.DataTablePiezo.AddColumn(this.GetTraduzioneLabel('Generic','TKN_VISIBILE',this.LinguaUtente),
                                        TZDTableColumnType.typBoolean,
                                        'MOSTRA_PACKER',
                                        '12%')
    ColonnaPiezo.DefaultValue = false
    ColonnaPiezo.Necessario = false
    this.Piezometro.sort((a, b) => a.NUMERO_PIEZOMETRO - b.NUMERO_PIEZOMETRO);
    this.DataTablePiezo.AssignDati(this.Piezometro)

    this.DataTablePacker = new TZDataTable('CATENA')
    this.DataTablePacker.Configurazione.Larghezza = '1016px'
    // this.DataTablePacker.TastoAggiungiVisibile    = false
    this.DataTablePacker.EditRicercaVisibile      = false
    this.DataTablePacker.Configurazione.AltezzaTutteLeRighe = '38px'
    this.DataTablePacker.ClearColumns()
    let ColonnaPacker = this.DataTablePacker.AddColumn(this.GetTraduzioneLabel('Generic','TKN_DESCRIZIONE',this.LinguaUtente),
                                         TZDTableColumnType.typString, 
                                         'DESCRIZIONE',
                                         '30%')
    ColonnaPacker = this.DataTablePacker.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_DALLA_PROF',this.LinguaUtente),
                                        TZDTableColumnType.typCentesimi,
                                        'DALLA_PROFONDITA',
                                        '13%')
    ColonnaPacker.DefaultValue = 0
    ColonnaPacker = this.DataTablePacker.AddColumn(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_ALLA_PROF',this.LinguaUtente),
                                        TZDTableColumnType.typCentesimi,
                                        'ALLA_PROFONDITA',
                                        '13%')
    ColonnaPacker.DefaultValue = 0
    ColonnaPacker = this.DataTablePacker.AddColumn(this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente),
                                        TZDTableColumnType.typColor,
                                        'COLORE',
                                        '29%')
    ColonnaPacker.Necessario = false
    this.DataTablePacker.AssignDati(this.Packer)
  }
}

class TPlaceholder
{
  constructor(ChiaveCatena, CoordPlaceholderX, CoordPlaceholderY, Raggio, FuoriServizio, MouseInfoPlaceholder, Descrizione, TextSizeTitlePlaceholder, ColorTitlePlaceholder, PositionPlaceholder, CfgInclinometro, CfgSghembo, CfgPiezometro, CfgEstensimetro, CfgTemperatura, CfgAccelerometro, ColorAlarmPh, ColorAlarmEmpty, MenuImpostazioniPlaceholder, Immagine, CatenaSoloPiezo)
  {
    this.Chiave                      = ChiaveCatena
    this.CoordPlaceholderX           = CoordPlaceholderX
    this.CoordPlaceholderY           = CoordPlaceholderY
    this.Raggio                      = Raggio
    this.FuoriServizio               = FuoriServizio
    this.MouseInfoPlaceholder        = MouseInfoPlaceholder
    this.Descrizione                 = Descrizione
    this.TextSizeTitlePlaceholder    = TextSizeTitlePlaceholder
    this.ColorTitlePlaceholder       = ColorTitlePlaceholder
    this.ColorAlarmPh                = ColorAlarmPh
    this.ColorAlarmEmpty             = ColorAlarmEmpty
    this.PositionPlaceholder         = PositionPlaceholder
    this.CfgInclinometro             = CfgInclinometro
    this.CfgSghembo                  = CfgSghembo
    this.CfgPiezometro               = CfgPiezometro
    this.CfgEstensimetro             = CfgEstensimetro
    this.CfgTemperatura              = CfgTemperatura
    this.CfgAccelerometro            = CfgAccelerometro
    this.MenuImpostazioniPlaceholder = MenuImpostazioniPlaceholder
    this.Immagine                    = Immagine
    this.CatenaSoloPiezo             = CatenaSoloPiezo
  }
}

export default
{
    emits: ['onSitoCambiato'],
    mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni],
    components: { 
                  VUEModal, 
                  VUEConfirm, 
                  VUEComponenteGraficoGenerico, 
                  VUEPopupGraficaCatena, 
                  VUEPopupColoriGraficaCatena,
                  VUEDataTable, 
                  VUEColorPicker, 
                  VUEPopupWarning,
                  VUEModalCaricamentoDati,
                  VUELegalFooter,
                  VUEPopupDatiAssistenza 
                },
    data() 
    {
        return {
            PlaceholderArray            : [],
            Admin                       : false,
            CambioSitoInCorso           : false,
            MenuImpostazioniPlaceholder : false,
            IsSitoMostraSoloMeteo       : false,
            CaricamentoDatiSiti         : false,
            EnableAlarmInfo             : false,
            OpzioniGraficiPiezometri    : OPZIONI_GRAFICI_PIEZOMETRI,
            IntervalliTeporali          : INTERVALLI_DI_TEMPO,
            OraPreimpostata             : '',
            ListaSiti                   : [],
            SitoSelezionato             : {},
            CatenaSelezionata           : null,
            IndexCatena                 : -1,
            Immagine                    : new Image(),
            ObjStyleCanvas              : {},
            MenuNuovo                   : [],
            GraphicDetails              : {
                                             StdHeight : 0,
                                             StdWidth  : 0,
                                             Zoom      : 1,
                                             OldZoom   : 1,
                                             ZoomX     : 0,
                                             ZoomY     : 0,
                                             dx        : 0,
                                             dy        : 0
                                          },
            DragMode                    : {xStart: 0, yStart: 0, xAngolo: 0, yAngolo: 0},
            MenuFilter                  : [],
            CurrentYear                 : (new Date()).getFullYear(),
            Arancione                   : COLORI_PANTONE.Arancione,
            Marrone                     : COLORI_PANTONE.Marrone,
            ArancioneSfondo             : SFONDO.Arancione,
            PopupCatenaGenerale         : false,
            PopupEliminazione           : false,
            PopupGraficaAllCatene       : false,
            PopupGraficaColoriAllCatene : false,
            PopupSelezioneNuovaData     : false,
            PopupImpostaProfondita      : false,
            PopupTipologiaModuli        : false,
            PopupColorPicker            : false,
            TestoPopupEliminazione      : '',
            TitoloPopupCatena           : '',
            MenuCateneAperto            : false,
            MenuGraficiAbbinatiAperto   : false,
            AltezzaCanvas               : 0,
            Tabs                        : {Configurazione       : this.GetTraduzioneLabel('Generic','TKN_CONFIGURAZIONE', SystemInformation.UserInformation.Lingua),
                                           InfoCatena           : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_INFO_CAT', SystemInformation.UserInformation.Lingua),
                                           Sensori              : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_SENSO', SystemInformation.UserInformation.Lingua),
                                           Piezometri           : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_PIEZO', SystemInformation.UserInformation.Lingua),
                                           ConfigurazionePiezo  : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_PIEZO', SystemInformation.UserInformation.Lingua),
                                           ConfigurazionePacker : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_PACKER', SystemInformation.UserInformation.Lingua)},
            TabSelezionato              : this.GetTraduzioneLabel('Generic','TKN_CONFIGURAZIONE', SystemInformation.UserInformation.Lingua),
            TabSelezionatoPiezo         : this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_TAB_PIEZO', SystemInformation.UserInformation.Lingua),
            AltezzaPopupCatena          : 0,
            AltezzaDataTable            : 0,
            CatenaDaEliminare           : null,            
            ObjGrafica                  : {
                                            AxisX: {},
                                            AxisY: {}
                                          },          
            ObjGraficaColori            : {
                                            ColorePrincipale: '',
                                            Background: ''
                                          },
            Markups                     : SystemInformation.TipiMarkup,
            MenuTrigger                 : SystemInformation.MenuTrigger,
            Timer                       : null,
            Contatore                   : 0,
            ObjAllineamento             : { 
                                            DataAllineamento    : null,
                                            ListaOre            : [],
                                            OrarioAllineamento  : null,
                                            DataOraAllineamento : null,
                                            DatiTrovati         : true
                                          },
            PopupSelezioneAllineamento  : false,
            SpostamentoAbilitato        : false,
            MostraGrafici               : false,
            TempGraphicDetails          : null,
            NuovaDataGrafico            : null,
            ProfonditaImpostata         : 0,
            ImpostaInclinometro         : false,
            ImpostaEstensimetro         : false,
            ImpostaPiezometro           : false,
            ImpostaTermometro           : false,
            ImpostaAccelerometro       : false,
            ImpostaMagnetometro         : false,
            NuovaOraGrafico             : null,
            ListaGrafici                : [],         
            ListaMarkup                 : SystemInformation.TipiMarkup,
            GraficoSelezionato          : null,
            ColoreInModifica            : {},
            MostraUltimoGrafico         : true,
            GraficiChange               : 0,
            UltimaData                  : null,
            ListaOre                    : [],
            PopupAvvisoData             : false,
            TestoPopupData              : '',
            GraphScale                  : {
                                            Max : 0,
                                            Min : 0,
                                            Udm : 0
                                          },
            AdjZoom                     : 1,
            Polare                      : TIPI_GRAFICI.Polare,
            PopupDimPlaceholder         : false,
            URLSchedaVerticali          : '/appMainWindow/GraficiVerticaliModulabili?',
            NewDimPlaceholder           : 0,
            Loading                     : false,
            Repaint                     : 0,
            MostraIconaAllarme          : SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore,
            TickIntervallo              : SystemInformation.Configurazione.TICK_INTERVAL,
            SfondoAllineamento          : 'black',
            ColorTextDashboard          : 'black',
            LinguaUtente                : SystemInformation.UserInformation.Lingua,
            PopupDatiAssistenza         : false,
            Mobile                      : TZGenericFunct.IsClientMobile(),
            StartDistance               : 0
        };
    },
    methods: 
    {
      CalcolaDistanzaTocchi(x1, x2, y1, y2)
      {
        let x = Math.pow(x1 - x2, 2)
        let y = Math.pow(y1 - y2, 2)
        return Math.sqrt(x + y)
      },

      OnTouchStart(event)
      {
        if (event.touches.length == 2)
        {
          // this.$refs.Canvas.removeEventListener('pointermove', this.DragImage)
          this.OnMouseUp()
          let x1 = event.touches[0].clientX
          let x2 = event.touches[1].clientX
          let y1 = event.touches[0].clientY
          let y2 = event.touches[1].clientY
          this.StartDistance = this.CalcolaDistanzaTocchi(x1, x2, y1, y2)
        }
      },

      OnTouchMove(event)
      {
        if (event.touches.length == 2)
        {
          let x1 = event.touches[0].clientX
          let x2 = event.touches[1].clientX
          let y1 = event.touches[0].clientY
          let y2 = event.touches[1].clientY
          let Distance = this.CalcolaDistanzaTocchi(x1, x2, y1, y2)
          
          let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
          this.GraphicDetails.OldZoom = this.GraphicDetails.Zoom
          this.GraphicDetails.Zoom = this.GraphicDetails.Zoom * (Distance / this.StartDistance)
          this.GraphicDetails.ZoomX = ((Math.abs(x1 - x2)) / 2) + Coords.x + Math.min(x1, x2)
          this.GraphicDetails.ZoomY = ((Math.abs(y1 - y2)) / 2) + Coords.y + Math.min(y1, y2)

          let minZoomTouch = this.GetMinZoom()
          if (this.GraphicDetails.Zoom < minZoomTouch)
            this.GraphicDetails.Zoom = minZoomTouch
          if (this.GraphicDetails.Zoom > MAX_ZOOM)
            this.GraphicDetails.Zoom = MAX_ZOOM

          this.GraphicDetails.dx = (1 - (this.GraphicDetails.Zoom / this.GraphicDetails.OldZoom)) * (this.GraphicDetails.ZoomX - this.GraphicDetails.dx) + this.GraphicDetails.dx
          this.GraphicDetails.dy = (1 - (this.GraphicDetails.Zoom / this.GraphicDetails.OldZoom)) * (this.GraphicDetails.ZoomY - this.GraphicDetails.dy) + this.GraphicDetails.dy

          this.DragMode.xAngolo = this.GraphicDetails.dx
          this.DragMode.yAngolo = this.GraphicDetails.dy
          this.DrawMap()
          this.StartDistance = Distance
        }
      },

      GetLastAllarmeString(ChiaveCatena)
      {
        let ObjCatena = this.SitoSelezionato.DatiCatene.find((element) => {return element.DatiCatena.CHIAVE == ChiaveCatena})
        if (ObjCatena.LastAllarme != null)
          return ObjCatena.LastAllarme.TIPO_ALLARME + " - " + ObjCatena.LastAllarme.DATA_INIZIO
      },

      GetSvg(Placeholder,Allarme)
      {  
         var Result =  ObjIconaAllarme.IconaAllarmeVuotoRosso;
         Result = Result.replace(/width="\d+"/, `width="${Placeholder.MouseInfoPlaceholder.Detail.width}"`);
         Result = Result.replace(/height="\d+"/, `height="${Placeholder.MouseInfoPlaceholder.Detail.height}"`);   
         Result = Result.replace("red",Allarme ? Placeholder.ColorAlarmPh : Placeholder.ColorAlarmEmpty)   
         return Result;
      },

      OrdinaDate()
      {
        this.ListaOre.sort()
      },

      AssignImpostaProfondita()
      {
        this.PopupImpostaProfondita = true
      },

      AnnullaImpostaProfondita()
      {
        this.PopupImpostaProfondita = false
      },

      AggiornaImpostaProfondita()
      {
        let NuovaProfondita = parseInt(this.ProfonditaImpostata) * 100
        for (let i = 0; i < this.CatenaSelezionata.Moduli.length; i++)
        {
          this.CatenaSelezionata.Moduli[i].PROFONDITA_CODA  = NuovaProfondita
          this.CatenaSelezionata.Moduli[i].PROFONDITA_TESTA = this.CatenaSelezionata.Moduli[i].PROFONDITA_CODA - this.CatenaSelezionata.Moduli[i].LUNGHEZZA_SPEZZONE
          NuovaProfondita = this.CatenaSelezionata.Moduli[i].PROFONDITA_TESTA 
        }
        this.CatenaSelezionata.Clear()
        this.CatenaSelezionata.Disponi(()=>{this.PopupCatenaGenerale = true})
        this.PopupImpostaProfondita = false
      },

      AssignTipologiaModuli()
      {
        this.PopupTipologiaModuli = true
      },

      AnnullaTipologiaModuli()
      {
        this.PopupTipologiaModuli = false
      },

      AggiornaTipologiaModuli()
      {
        for (let i = 0; i < this.CatenaSelezionata.Moduli.length; i++)
        {
          if(this.ImpostaInclinometro)
            this.CatenaSelezionata.Moduli[i].INCLINOMETRO = "T"
          else
            this.CatenaSelezionata.Moduli[i].INCLINOMETRO = "F"
          
          if(this.ImpostaEstensimetro)
            this.CatenaSelezionata.Moduli[i].ESTENSIMETRO = "T"
          else
            this.CatenaSelezionata.Moduli[i].ESTENSIMETRO = "F"
          
          if(this.ImpostaPiezometro)
            this.CatenaSelezionata.Moduli[i].PIEZOMETRO = "T"
          else
            this.CatenaSelezionata.Moduli[i].PIEZOMETRO = "F"
          
          if(this.ImpostaTermometro)
            this.CatenaSelezionata.Moduli[i].TERMOMETRO = "T"
          else
            this.CatenaSelezionata.Moduli[i].TERMOMETRO = "F"
          
          if(this.ImpostaAccelerometro)
            this.CatenaSelezionata.Moduli[i].ACCELEROMETRO = "T"
          else
            this.CatenaSelezionata.Moduli[i].ACCELEROMETRO = "F"
          
          if(this.ImpostaMagnetometro)
            this.CatenaSelezionata.Moduli[i].MAGNETOMETRO = "T"
          else
            this.CatenaSelezionata.Moduli[i].MAGNETOMETRO = "F"
        }
        this.CatenaSelezionata.Clear()
        this.CatenaSelezionata.Disponi(() => { this.PopupCatenaGenerale = true })
        this.PopupTipologiaModuli = false
      },

      ResetDefaultMostraIdPiezometri()
      {
        if(this.CatenaSelezionata.DatiGenerali.PIEZOMETRO_DI_RIFERIMENTO != -1)
          this.CatenaSelezionata.DatiGenerali.MOSTRA_ID_PIEZOMETRI = false
      },

      // SEZIONE GESTIONE DATI
      LoadXMLFile()
      {
        let Self = this
        var Reader  = new FileReader()
        let XmlFile = document.getElementById('InputXML')
        Reader.onload = function (e)
                        {
                          let FileInBase64 = e.target.result.split(',')[1]

                          let parser = new DOMParser()
                          let Xml = parser.parseFromString(window.atob(FileInBase64),"text/xml")

                          let Node = Xml.documentElement
                          let NodoConfigurazione = null
                          let NodoSensori        = null

                          Self.CatenaSelezionata.Clear()

                          for(let i = 0; i < Node.childNodes.length; i++)
                          {
                            if(Node.childNodes[i].nodeName == 'Configurazione')
                              NodoConfigurazione = Node.childNodes[i]

                            if(Node.childNodes[i].nodeName == 'ConfigurazioneSensori')              
                              NodoSensori = Node.childNodes[i]
                          }

                          if(NodoConfigurazione != null)
                          {
                            let DatiGenerali = Self.CatenaSelezionata.DatiGenerali
                            
                            for(let i = 0; i < NodoConfigurazione.childNodes.length; i++)
                            {
                              let NomeNodo  = NodoConfigurazione.childNodes[i].nodeName
                              let NodeValue = NodoConfigurazione.childNodes[i].textContent

                              switch (NomeNodo)
                              {
                                case 'NOME'                    : DatiGenerali.DESCRIZIONE        = TSchedaGenerica.DisponiFromString(NodeValue);
                                                                 DatiGenerali.IDENTIFICATIVO     = TSchedaGenerica.DisponiFromString(NodeValue); break
                                case 'SITO'                    : DatiGenerali.SITO               = TSchedaGenerica.DisponiFromString(NodeValue); break
                                case 'MONITORAGGIO'            : DatiGenerali.MONITORAGGIO       = TSchedaGenerica.DisponiFromString(NodeValue); break
                                case 'RAGIONE_SOCIALE_CLIENTE' : DatiGenerali.CLIENTE            = TSchedaGenerica.DisponiFromString(NodeValue); break
                                case 'DATA_INSTALLAZIONE'      : DatiGenerali.DATA_INSTALLAZIONE = TZDateFunct.DateInHTMLInputFormat(new Date(NodeValue)); break
                                case 'PROGETTO'                : DatiGenerali.PROGETTO           = TSchedaGenerica.DisponiFromString(NodeValue); break
                                case 'NOTE'                    : DatiGenerali.NOTE               = TSchedaGenerica.DisponiFromString(NodeValue); break
                                case 'DATA_CALIBRAZIONE'       : DatiGenerali.DATA_CALIBRAZIONE  = TZDateFunct.DateInHTMLInputFormat(new Date(NodeValue)); break
                                case 'FUORI_SERVIZIO'          : DatiGenerali.FUORI_SERVIZIO     = TSchedaGenerica.DisponiFromBoolean(NodeValue); break
                                case 'PLUVIOMETRO'             : DatiGenerali.PLUVIOMETRO        = TSchedaGenerica.DisponiFromBoolean(NodeValue); break
                                case 'ANEMOMETRO'              : DatiGenerali.ANEMOMETRO         = TSchedaGenerica.DisponiFromBoolean(NodeValue); break
                                case 'TERMOMETRO'              : DatiGenerali.TERMOMETRO         = TSchedaGenerica.DisponiFromBoolean(NodeValue); break
                                case 'VERSIONE'                : DatiGenerali.VERSIONE           = TSchedaGenerica.DisponiFromString(NodeValue); break
                                case 'NUMERO_MANOMETRI'        : DatiGenerali.NUMERO_MANOMETRI   = TSchedaGenerica.DisponiFromInteger(NodeValue); break
                                case 'NUMERO_TENSIOMETRI'      : DatiGenerali.NUMERO_TENSIOMETRI = TSchedaGenerica.DisponiFromInteger(NodeValue); break
                                case 'INTERPOLAZIONE_MOD_LUNGHI' : DatiGenerali.INTERPOLAZIONE   = TSchedaGenerica.DisponiFromBoolean(NodeValue); break
                                case 'ORA_CALIBRAZIONE'        : DatiGenerali.ORA_CALIBRAZIONE   = NodeValue.split("T")[1]; break
                                case 'ORA_INSTALLAZIONE'       : DatiGenerali.ORA_INSTALLAZIONE  = NodeValue.split("T")[1]; break
                              }
                            }
                          }

                          Self.CatenaSelezionata.Moduli = []
                          
                          if (NodoSensori != null)
                          {
                            for(let i = 0; i < NodoSensori.childNodes.length; i++)
                            {
                              if (NodoSensori.childNodes[i].nodeName != '#text')
                                Self.CatenaSelezionata.Moduli.push(Self.ProcessaNodoSensori(NodoSensori.childNodes[i]))              
                            }
                          }

                          Self.CatenaSelezionata.Moduli.sort((ModuloA, ModuloB) => parseInt(ModuloA.MODULO) - parseInt(ModuloB.MODULO))

                          Self.CatenaSelezionata.DataTable.AssignDati(Self.CatenaSelezionata.Moduli)
                        } 
        Reader.readAsDataURL(XmlFile.files[0])
      },

      ConfermaColore()
      {
        this.GraficoSelezionato.Colore = this.ColoreInModifica.Colore
        this.CateneMostrate.forEach((SingleCatena) =>
        {
          let ObjData = SingleCatena.DatiCatena.Spostamenti.Date.find((element) => {return element.Data == this.GraficoSelezionato.Data})
          if (ObjData != undefined)
          {
            ObjData.Colore = this.GraficoSelezionato.Colore                                                              
          }
        })
        this.GraficiChange++
        this.AnnullaColore()
      },

      AnnullaColore()
      {
        this.ColoreInModifica = {}
        this.PopupColorPicker = false
      },

      RimuoviGrafico(Data)
      {
        let index = this.ListaGrafici.findIndex((element) => (element.Data == Data))
        this.ListaGrafici.splice(index, 1)
        let Parametri = {Chiave : this.SitoSelezionato.CHIAVE, Date : [], GetGraphsOnly : true}
        this.NuovaDataGrafico = null
        for (let i = 0; i < this.ListaGrafici.length; i++)
        {
          Parametri.Date.push(this.ListaGrafici[i].Data)
        }
        this.NuovaDataGrafico = null
        this.AggiungiDataAbbinato(Parametri)
      },

      ProcessaNodoSensori(Nodo)
      {
        let ObjModulo = {}

        for(let i = 0; i < Nodo.childNodes.length; i++)
        {
          let NomeNodo  = Nodo.childNodes[i].nodeName
          let NodeValue = Nodo.childNodes[i].textContent

          switch (NomeNodo)
          {
            case 'SENSORE'               : ObjModulo.MODULO                  = NodeValue; break
            case 'INCLINOMETRO'          : ObjModulo.INCLINOMETRO            = NodeValue; break
            case 'ESTENSIMETRO'          : ObjModulo.ESTENSIMETRO            = NodeValue; break
            case 'PIEZOMETRO'            : ObjModulo.PIEZOMETRO              = NodeValue; break
            case 'TERMOMETRO'            : ObjModulo.TERMOMETRO              = NodeValue; break
            case 'ACCELEROMETRO'         : ObjModulo.ACCELEROMETRO           = NodeValue; break
            case 'MAGNETOMETRO'          : ObjModulo.MAGNETOMETRO            = NodeValue; break
            case 'PROFONDITA_TESTA'      : ObjModulo.PROFONDITA_TESTA        = NodeValue / 10; break
            case 'PROFONDITA'            : ObjModulo.PROFONDITA_CODA         = NodeValue / 10; break
            case 'LUNGHEZZA_MODULO'      : ObjModulo.LUNGHEZZA_SPEZZONE      = NodeValue / 10; break
            case 'ORIENTAMENTO'          : ObjModulo.ORIENTAMENTO            = NodeValue / 10; break
            case 'SEGMENTO_DEFORM_START' : ObjModulo.SEGMENTO_DEFORMAZIONE_A = NodeValue / 10; break
            case 'SEGMENTO_DEFORM_END'   : ObjModulo.SEGMENTO_DEFORMAZIONE_B = NodeValue / 10; break
            case 'PRESSIONE_SECCO_PIEZOMETRO' : ObjModulo.PRESSIONE_SECCO    = NodeValue; break
            case 'QUOTA_PIEZOMETRO'      : ObjModulo.QUOTA_PIEZOMETRO        = NodeValue * 100; break
          }
        }
        return ObjModulo
      },

      LoadSite(Site)
      {
        let Self      = this
        let Parametri = { Chiave : Site.CHIAVE }
        TZGenericFunct.ChangeURLParameters({ ChiaveSito : Site.CHIAVE })

        if (this.ObjAllineamento.DataOraAllineamento != null)
          Parametri.Allineamento = TSchedaGenerica.PrepareForRecordDateTime(this.ObjAllineamento.DataOraAllineamento)

        this.PlaceholderArray           = []
        this.CambioSitoInCorso          = true
        this.CaricamentoDatiSiti        = true
        this.SitoSelezionato            = Site
        this.$emit('onSitoCambiato', Site)
        this.SfondoAllineamento         = Site.SFONDO_ALLINEAMENTO
        this.ColorTextDashboard         = Site.NOTE_LEGALI
        this.SitoSelezionato.DatiCatene = []
        this.Immagine.onload            = () => {
                                                  this.CalculateCanvasDimensions();
                                                  this.DrawMap()
                                                }

        SystemInformation.AdvQuery.ExecuteExternalScript('ExtraDatiCatene', Parametri, function(Answer) 
        {
          Self.AssignListaGraficiCatene(Site, Answer.QueryData)

          if (Site.ALLEGATO == '' || Site.ALLEGATO == undefined)
          {
            Self.Immagine.src      = IMMAGINE_SITO_DEFAULT
            Self.CambioSitoInCorso = false
          }
          else
          {
            if(Site.ALLEGATO.split(';')[0].indexOf('data:') !== -1) {
              SystemInformation.AdvQuery.GetAttachment(Site.ALLEGATO.split(';')[1],
                                                    function(Result)
                                                    {
                                                      Self.Immagine.src = Site.ALLEGATO.split(';')[0] + ';base64,' + Result
                                                      Self.CambioSitoInCorso = false                                                                       
                                                    },
                                                    function(HTTPError,SubHTTPError,Response)
                                                    {
                                                      if (Response != 20)
                                                        SystemInformation.HandleError(HTTPError,SubHTTPError,Response)
                                                      else
                                                      {
                                                        console.error(Self.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_IMG_SITO_NON_TROVATA',Self.LinguaUtente))
                                                        Self.Immagine.src = IMMAGINE_SITO_DEFAULT
                                                        Self.CambioSitoInCorso = false
                                                      }
                                                    })
            } else {
              Self.Immagine.src = process.env.VUE_APP_URL_ADMIN + '/storage/' + Site.ALLEGATO
              Self.CambioSitoInCorso = false
            }
          }
          Self.CaricamentoDatiSiti = false
        },
        function(ErrorMessage,DescrErrore)
        {
          Self.CaricamentoDatiSiti = false
          alert(ErrorMessage + '[' + DescrErrore + ']')
        })
      },

      AssignDimensioniGraficiCatene()
      {
        for (let i = 0; i < this.SitoSelezionato.DatiCatene.length; i++)
        {
          let ObjCatena                   = this.SitoSelezionato.DatiCatene[i]
          ObjCatena.MouseInfo.Coordinates = {
                                              x: ObjCatena.DimensioniRelative.POS_X * (this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom) + this.GraphicDetails.dx, 
                                              y: ObjCatena.DimensioniRelative.POS_Y * (this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom) + this.GraphicDetails.dy
                                            }
          ObjCatena.MouseInfo.Detail      = {
                                              xStart  : ObjCatena.MouseInfo.Coordinates.x,
                                              yStart  : ObjCatena.MouseInfo.Coordinates.y,
                                              xAngolo : ObjCatena.MouseInfo.Coordinates.x,
                                              yAngolo : ObjCatena.MouseInfo.Coordinates.y, 
                                              width   : ObjCatena.DimensioniRelative.LARGHEZZA * this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom, 
                                              height  : ObjCatena.DimensioniRelative.ALTEZZA * this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom
                                            }
        }
      },

      AssignDimensioniPlaceholder()
      {
        for (let i = 0; i < this.PlaceholderMostrati.length; i++)
        {
          let ObjPlaceholder = this.PlaceholderMostrati[i]
          ObjPlaceholder.MouseInfoPlaceholder.Coordinates = {
                                                              x: ObjPlaceholder.CoordPlaceholderX * (this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom)  + this.GraphicDetails.dx + DIM_PLACEHOLDER * ((this.GraphicDetails.Zoom - 1) / 2), 
                                                              y: ObjPlaceholder.CoordPlaceholderY * (this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom) + this.GraphicDetails.dy + DIM_PLACEHOLDER * ((this.GraphicDetails.Zoom - 1) / 2)
                                                            }
          ObjPlaceholder.MouseInfoPlaceholder.Detail =  {
                                                          xStart  : ObjPlaceholder.MouseInfoPlaceholder.Coordinates.x,
                                                          yStart  : ObjPlaceholder.MouseInfoPlaceholder.Coordinates.y,
                                                          xAngolo : ObjPlaceholder.MouseInfoPlaceholder.Coordinates.x,
                                                          yAngolo : ObjPlaceholder.MouseInfoPlaceholder.Coordinates.y, 
                                                          width   : DIM_PLACEHOLDER,
                                                          height  : DIM_PLACEHOLDER
                                                        }
        }
      },

      AssignListaGraficiCatene(Site, Catene)
      {
        Site.DatiCatene       = []
        this.PlaceholderArray = []
        let MaxMinGraph = 0 

        for (let i = 0; i < Catene.length; i++)
        {
          let Catena                              = Catene[i]
          let ObjCatena                           = {}
          let ValoreMassimoGrafico                = 0
          ObjCatena.MouseInfo                     = {}
          ObjCatena.DatiCatena                    = {}
          ObjCatena.DatiCatena.CHIAVE_SITO        = Site.CHIAVE
          ObjCatena.DatiCatena.CHIAVE             = TSchedaGenerica.DisponiFromListIndex(Catena.CHIAVE)
          ObjCatena.DatiCatena.DESCRIZIONE        = TSchedaGenerica.DisponiFromString(Catena.DESCRIZIONE)
          ObjCatena.DatiCatena.INTERPOLAZIONE     = TSchedaGenerica.DisponiFromBoolean(Catena.INTERPOLAZIONE)
          ObjCatena.DatiCatena.IDENTIFICATIVO     = TSchedaGenerica.DisponiFromString(Catena.IDENTIFICATIVO)
          ObjCatena.DatiCatena.DATA_INSTALLAZIONE = TSchedaGenerica.DisponiFromString(Catena.DATA_INSTALLAZIONE)
          ObjCatena.DatiCatena.DATA_CALIBRAZIONE  = TSchedaGenerica.DisponiFromString(Catena.DATA_CALIBRAZIONE)
          ObjCatena.DatiCatena.FUORI_SERVIZIO     = TSchedaGenerica.DisponiFromBoolean(Catena.FUORI_SERVIZIO)
          ObjCatena.DatiCatena.NR_ACCELEROMETRI   = TSchedaGenerica.DisponiFromInteger(Catena.NR_ACCELEROMETRI)
          ObjCatena.DatiCatena.INCLINOMETRI       = TSchedaGenerica.DisponiFromInteger(Catena.NR_INCLINOMETRI) > 0
          ObjCatena.DatiCatena.ANEMOMETRO         = TSchedaGenerica.DisponiFromBoolean(Catena.ANEMOMETRO)
          ObjCatena.DatiCatena.PLUVIOMETRO        = TSchedaGenerica.DisponiFromBoolean(Catena.PLUVIOMETRO)
          ObjCatena.DatiCatena.TERMOMETRO         = TSchedaGenerica.DisponiFromBoolean(Catena.TERMOMETRO)
          ObjCatena.DatiCatena.CatenaSoloMeteo    = false
          ObjCatena.DatiCatena.CatenaSoloPiezo    = false

          if ((ObjCatena.DatiCatena.ANEMOMETRO || ObjCatena.DatiCatena.PLUVIOMETRO || ObjCatena.DatiCatena.TERMOMETRO) && !ObjCatena.DatiCatena.INCLINOMETRI)
          {
            ObjCatena.DatiCatena.CatenaSoloMeteo = true
          }

          ObjCatena.DatiCatena.Spostamenti    = Catena.Spostamenti
          
          if (ObjCatena.DatiCatena.Spostamenti != undefined)
          {
            let index                 = ObjCatena.DatiCatena.Spostamenti.Date.findIndex((element) => (element.Ultima))
            let SumSpostEst           = 0
            let SumSpostNord          = 0
            let SumSpostAllineatoNord = 0
            let SumSpostAllineatoEst  = 0

            if (index != -1 && (this.UltimaData == null || this.UltimaData < ObjCatena.DatiCatena.Spostamenti.Date[index].Data))
              this.UltimaData = ObjCatena.DatiCatena.Spostamenti.Date[index].Data

            for (let j = 0; j < ObjCatena.DatiCatena.Spostamenti.Date.length; j++)
            {
              let Spostamenti = ObjCatena.DatiCatena.Spostamenti.Date[j].Moduli

              for (let k = 0; k < Spostamenti.length; k++)
              {
                let Spostamento = Spostamenti[k]
                let Allineamento = null

                if (Catena.Allineamento != null)
                  Allineamento = Catena.Allineamento[k]

                if (Allineamento != null)
                {
                  SumSpostAllineatoNord = SumSpostAllineatoNord + Allineamento.SpostamentoNord / 1000
                  SumSpostAllineatoEst  = SumSpostAllineatoEst + Allineamento.SpostamentoEst / 1000

                  if (Math.abs(SumSpostAllineatoEst) > MaxMinGraph)
                    MaxMinGraph = Math.abs(SumSpostAllineatoEst)

                  if (Math.abs(SumSpostAllineatoNord) > MaxMinGraph)
                    MaxMinGraph = Math.abs(SumSpostAllineatoNord)     

                  if (Math.abs(SumSpostAllineatoEst) > ValoreMassimoGrafico)
                    ValoreMassimoGrafico = Math.abs(SumSpostAllineatoEst)

                  if (Math.abs(SumSpostAllineatoNord) > ValoreMassimoGrafico)
                    ValoreMassimoGrafico = Math.abs(SumSpostAllineatoNord)              
                }
                else
                {
                  SumSpostEst  = SumSpostEst + Spostamento.SpostamentoEst / 1000
                  SumSpostNord = SumSpostNord + Spostamento.SpostamentoNord / 1000

                  if (Math.abs(SumSpostEst) > MaxMinGraph)
                    MaxMinGraph = Math.abs(SumSpostEst)

                  if (Math.abs(SumSpostNord) > MaxMinGraph)
                    MaxMinGraph = Math.abs(SumSpostNord)

                  if (Math.abs(SumSpostEst) > ValoreMassimoGrafico)
                    ValoreMassimoGrafico = Math.abs(SumSpostEst)

                  if (Math.abs(SumSpostNord) > ValoreMassimoGrafico)
                    ValoreMassimoGrafico = Math.abs(SumSpostNord)
                }
              }
            }
          }
          ObjCatena.DatiCatena.Allineamento = Catena.Allineamento
          ObjCatena.DatiGrafici             = {
                                                TITLE_COLOR               : TSchedaGenerica.DisponiFromString(Catena.GRAPH_TITLE_COLOR),
                                                TITLE_FONT_SIZE           : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_TITLE_FONT_SIZE),
                                                BACKGROUND                : TSchedaGenerica.DisponiFromString(Catena.GRAPH_BACKGROUND),        
                                                COLOR                     : TSchedaGenerica.DisponiFromString(Catena.GRAPH_COLOR),
                                                MARKUP                    : TSchedaGenerica.DisponiFromString(Catena.GRAPH_MARKUP),
                                                MARKUP_WIDTH              : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_MARKUP_WIDTH),
                                                PEN_WIDTH                 : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_PEN_WIDTH),
                                                DRAW_TITLE_STROKE         : TSchedaGenerica.DisponiFromBoolean(Catena.GRAPH_DRAW_TITLE_STROKE),
                                                COLOR_TITLE_STROKE        : TSchedaGenerica.DisponiFromString(Catena.GRAPH_COLOR_TITLE_STROKE),
                                                DRAW_BORDERS              : TSchedaGenerica.DisponiFromBoolean(Catena.GRAPH_DRAW_BORDERS),
                                                AXES_COLOR                : TSchedaGenerica.DisponiFromString(Catena.GRAPH_AXES_COLOR),
                                                AXES_PEN_WIDTH            : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_PEN_WIDTH),
                                                AXES_MIN                  : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_MAX) * -1,
                                                AXES_MAX                  : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_MAX),
                                                AXES_MAX_CALCOLATO        : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_MAX),
                                                NOTCH_SIZE                : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_NOTCH_SIZE) != 0 ? TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_NOTCH_SIZE) : 1,
                                                NOTCH_FONT_SIZE           : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_NOTCH_FONT_SIZE),
                                                NOTCH_PEN_WIDTH           : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_NOTCH_PEN_WIDTH),
                                                NOTCH_COLOR               : TSchedaGenerica.DisponiFromString(Catena.GRAPH_AXES_NOTCH_COLOR),
                                                AXES_FONT_SIZE            : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_AXES_FONT_SIZE),
                                                AXES_FONT_COLOR           : TSchedaGenerica.DisponiFromString(Catena.GRAPH_AXES_FONT_COLOR),
                                                AXES_LABEL_TYPE           : TSchedaGenerica.DisponiFromString(Catena.GRAPH_AXES_LABEL_TYPE),
                                                AXES_LABELS_USE_BOLD      : TSchedaGenerica.DisponiFromBoolean(Catena.GRAPH_AXES_LABELS_USE_BOLD),
                                                DRAW_LATERAL_LABELS       : TSchedaGenerica.DisponiFromBoolean(Catena.GRAPH_DRAW_LATERAL_LABELS),
                                                GRAPH_AUTO_SCALE          : TSchedaGenerica.DisponiFromBoolean(Catena.GRAPH_AUTO_SCALE),
                                                DRAW_NOTCH_LABELS         : TSchedaGenerica.DisponiFromBoolean(Catena.GRAPH_DRAW_NOTCH_LABELS),
                                                PLACEHOLDER_DIM           : TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_PLACEHOLDER_DIM),
                                                PLACEHOLDER_TITLE_SIZE    : TSchedaGenerica.DisponiFromInteger(Catena.PLACEHOLDER_TITLE_SIZE),
                                                PLACEHOLDER_TITLE_COLOR   : TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_TITLE_COLOR),
                                                PLACEHOLDER_TEXT_POSITION : TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_TEXT_POSITION),
                                                CFG_INCLINOMETRO          : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_INCLINOMETRO),
                                                CFG_SGHEMBO               : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_SGHEMBO),
                                                CFG_PIEZOMETRO            : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_PIEZOMETRO),
                                                CFG_ESTENSIMETRO          : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_ESTENSIMETRO),
                                                CFG_TEMPERATURA           : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_TEMPERATURA),
                                                CFG_ACCELEROMETRO         : TSchedaGenerica.DisponiFromInteger(Catena.CFG_ACCELEROMETRO),
                                                PLACEHOLDER_ALARM_COLOR   : TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_ALARM_COLOR),
                                                PLACEHOLDER_ALARM_EMPTY_CL: TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_ALARM_EMPTY_CL),
                                              }
                                              
          // MaxNotchAllCatene = Math.max(MaxNotchAllCatene, ObjCatena.DatiGrafici.AXES_MAX)
          
          if (ObjCatena.DatiGrafici.GRAPH_AUTO_SCALE)
          {
            ObjCatena.DatiGrafici.AXES_MAX_CALCOLATO = ValoreMassimoGrafico
          }
          
          ObjCatena.Moduli                  = []
          ObjCatena.EstensimetroPresente    = Catena.EstensimetriPresenti
          ObjCatena.Packer                  = []
          ObjCatena.Piezometro              = []
          let ObjNumeroPiezometri           = []

          for (let j = 0; j < Catena.ModuliConfig.length; j++)
          {
            let Modulo    = Catena.ModuliConfig[j]
            let ObjModulo = {}
            // ObjModulo = {
            //               CATENA                  : TSchedaGenerica.DisponiFromListIndex(Modulo.CATENA),
            //               MODULO                  : TSchedaGenerica.DisponiFromListIndex(Modulo.MODULO),
            //               INCLINOMETRO            : TSchedaGenerica.DisponiFromBoolean(Modulo.INCLINOMETRO),
            //               ESTENSIMETRO            : TSchedaGenerica.DisponiFromBoolean(Modulo.ESTENSIMETRO),
            //               PIEZOMETRO              : TSchedaGenerica.DisponiFromBoolean(Modulo.PIEZOMETRO),
            //               TERMOMETRO              : TSchedaGenerica.DisponiFromBoolean(Modulo.TERMOMETRO),
            //               ACCELEROMETRO           : TSchedaGenerica.DisponiFromBoolean(Modulo.ACCELEROMETRO),
            //               MAGNETOMETRO            : TSchedaGenerica.DisponiFromBoolean(Modulo.MAGNETOMETRO),
            //               PROFONDITA_TESTA        : TSchedaGenerica.DisponiFromDouble(Modulo.PROFONDITA_TESTA, 2),
            //               PROFONDITA_CODA         : TSchedaGenerica.DisponiFromDouble(Modulo.PROFONDITA_CODA, 2),
            //               LUNGHEZZA_SPEZZONE      : TSchedaGenerica.DisponiFromDouble(Modulo.LUNGHEZZA_SPEZZONE, 2),
            //               ORIENTAMENTO            : TSchedaGenerica.DisponiFromDouble(Modulo.ORIENTAMENTO, 2),
            //               SEGMENTO_DEFORMAZIONE_A : TSchedaGenerica.DisponiFromDouble(Modulo.SEGMENTO_DEFORMAZIONE_A, 1),
            //               SEGMENTO_DEFORMAZIONE_B : TSchedaGenerica.DisponiFromDouble(Modulo.SEGMENTO_DEFORMAZIONE_B, 1),
            //             }
            ObjModulo     = {
                              CATENA                  : Modulo.CATENA,
                              MODULO                  : Modulo.MODULO,
                              INCLINOMETRO            : Modulo.INCLINOMETRO,
                              ESTENSIMETRO            : Modulo.ESTENSIMETRO,
                              PIEZOMETRO              : Modulo.PIEZOMETRO,
                              TERMOMETRO              : Modulo.TERMOMETRO,
                              ACCELEROMETRO           : Modulo.ACCELEROMETRO,
                              MAGNETOMETRO            : Modulo.MAGNETOMETRO,
                              PROFONDITA_TESTA        : Modulo.PROFONDITA_TESTA,
                              PROFONDITA_CODA         : Modulo.PROFONDITA_CODA,
                              LUNGHEZZA_SPEZZONE      : Modulo.LUNGHEZZA_SPEZZONE,
                              ORIENTAMENTO            : Modulo.ORIENTAMENTO,
                              SEGMENTO_DEFORMAZIONE_A : Modulo.SEGMENTO_DEFORMAZIONE_A,
                              SEGMENTO_DEFORMAZIONE_B : Modulo.SEGMENTO_DEFORMAZIONE_B,
                              PRESSIONE_SECCO         : Modulo.PRESSIONE_SECCO,
                              QUOTA_PIEZOMETRO        : Modulo.QUOTA_PIEZOMETRO
                            }

            if (ObjModulo.PIEZOMETRO == "T")
              ObjNumeroPiezometri.push(Modulo.MODULO)

            ObjCatena.Moduli.push(ObjModulo)
          }

          if (Catena.PiezometroConfig.length > 0)
          {
            for (let j = 0; j < Catena.PiezometroConfig.length; j++)
            {
              let Piezometro = Catena.PiezometroConfig[j]
              for (let k = 0; k < ObjNumeroPiezometri.length; k++)
              {
                let NumeroPiezometro = ObjNumeroPiezometri[k] 
                if (Piezometro.NUMERO_PIEZOMETRO == NumeroPiezometro)
                  ObjNumeroPiezometri.splice(k, 1)
              }
              let ObjPiezometro = {}
              ObjPiezometro = {
                            NUMERO_PIEZOMETRO       : Piezometro.NUMERO_PIEZOMETRO,
                            DALLA_PROFONDITA        : Piezometro.DALLA_PROFONDITA,
                            ALLA_PROFONDITA         : Piezometro.ALLA_PROFONDITA,
                            COLORE                  : Piezometro.COLORE,
                            MOSTRA_PACKER           : Piezometro.MOSTRA_PACKER,
                          }
              ObjCatena.Piezometro.push(ObjPiezometro)
            }
            for (let j = 0; j < ObjNumeroPiezometri.length; j++)
            {
              let NumeroPiezometro = ObjNumeroPiezometri[j]
              let ObjPiezometro = {}
              ObjPiezometro = { NUMERO_PIEZOMETRO : NumeroPiezometro }
              ObjCatena.Piezometro.push(ObjPiezometro)
            }
          }
          else
          {
            for (let j = 0; j < ObjNumeroPiezometri.length; j++)
            {
              let NumeroPiezometro = ObjNumeroPiezometri[j]
              let ObjPiezometro = {}
              ObjPiezometro = { NUMERO_PIEZOMETRO : NumeroPiezometro }
              ObjCatena.Piezometro.push(ObjPiezometro)
            }
          }

          if (Catena.PackerConfig.length > 0)
          {
            for (let j = 0; j < Catena.PackerConfig.length; j++)
            {
              let Packer = Catena.PackerConfig[j]
              let ObjPacker = {}
              ObjPacker = {
                            DESCRIZIONE             : Packer.DESCRIZIONE,
                            DALLA_PROFONDITA        : Packer.DALLA_PROFONDITA,
                            ALLA_PROFONDITA         : Packer.ALLA_PROFONDITA,
                            COLORE                  : Packer.COLORE,
                          }
              ObjCatena.Packer.push(ObjPacker)
            }
          }
          
          if (!ObjCatena.DatiCatena.INCLINOMETRI && ObjCatena.Piezometro != undefined && ObjCatena.Piezometro.length > 0)
          {
            ObjCatena.DatiCatena.CatenaSoloPiezo = true
          }

          ObjCatena.Allarmi = []
          ObjCatena.TipiAllarmiAttivi = []
          ObjCatena.LastAllarme = null
          // if (Catena.BLACKOUT_DATA != undefined)
          // {
          //   ObjCatena.TipiAllarmiAttivi.push('Blackout')
          //   ObjCatena.Allarmi.push({MODULO : '-', GRANDEZZA : 'ExtraBlackout', TIPO_ALLARME : 'ExtraBlackout', LIVELLO: 0})
          // }
          // for (let j = 0; j < Catena.Allarmi.length; j++)
          // {
          //   let Allarme = Catena.Allarmi[j]
          //   let ObjAllarme = {}
          //   ObjAllarme.MODULO = TSchedaGenerica.DisponiFromListIndex(Allarme.MODULO)
          //   ObjAllarme.GRANDEZZA = TSchedaGenerica.DisponiFromString(Allarme.GRANDEZZA)
          //   ObjAllarme.LIVELLO = TSchedaGenerica.DisponiFromInteger(Allarme.LIVELLO_ALLARME)
          //   for (var PropertyName in TIPI_GRANDEZZE_ALLARME)
          //   {
          //     if (TIPI_GRANDEZZE_ALLARME[PropertyName].includes(ObjAllarme.GRANDEZZA))
          //     {
          //       if (!(ObjCatena.TipiAllarmiAttivi.includes(PropertyName)))
          //       {
          //         ObjCatena.TipiAllarmiAttivi.push(PropertyName)
          //       }
          //     }
          //   }
          //   ObjAllarme.TIPO_ALLARME = TSchedaGenerica.DisponiFromString(Allarme.TIPO_ALLARME)
          //   ObjCatena.Allarmi.push(ObjAllarme)
          // }
          // while (ObjCatena.TipiAllarmiAttivi.length < 2 && ObjCatena.TipiAllarmiAttivi.length != 0)
          // {
          //   ObjCatena.TipiAllarmiAttivi.push(null)
          // }

          if (Catena.BLACKOUT_DATA != undefined)
          {
            ObjCatena.TipiAllarmiAttivi.push({TIPO: 'Blackout', LIVELLO: 0, ListaModuli: [{MODULO: '-', VALORE: '-'}]})
          }
          if (Catena.Allarmi.length > 0)
            ObjCatena.LastAllarme = Catena.Allarmi[0]
          for (let j = 0; j < Catena.Allarmi.length; j++)
          {
            let Allarme = Catena.Allarmi[j]
            let PropertyName = TIPOLOGIA_ALLARME_TO_UI[TSchedaGenerica.DisponiFromString(Allarme.TIPOLOGIA)]
            if (!PropertyName || !TIPI_GRANDEZZE_ALLARME[PropertyName])
              continue

            let Decimali = 3
            if (PropertyName == 'Termometro' || PropertyName == 'Pressione')
              Decimali = 2

            let IndexAllarmeAttivo = ObjCatena.TipiAllarmiAttivi.findIndex((element)=>(element.TIPO == PropertyName))
            if (IndexAllarmeAttivo != -1)
            {
              let LivelloAllarme = TSchedaGenerica.DisponiFromInteger(Allarme.LIVELLO_ALLARME)
              if (ObjCatena.TipiAllarmiAttivi[IndexAllarmeAttivo].LIVELLO < LivelloAllarme)
                ObjCatena.TipiAllarmiAttivi[IndexAllarmeAttivo].LIVELLO = LivelloAllarme
              ObjCatena.TipiAllarmiAttivi[IndexAllarmeAttivo].ListaModuli.push({MODULO: TSchedaGenerica.DisponiFromListIndex(Allarme.MODULO),
                                                                                VALORE: TSchedaGenerica.DisponiFromDouble(Allarme.VALORE, Decimali)})
            }
            else
            {
              ObjCatena.TipiAllarmiAttivi.push({TIPO: PropertyName, LIVELLO: TSchedaGenerica.DisponiFromInteger(Allarme.LIVELLO_ALLARME),
                                                ListaModuli: [{MODULO: TSchedaGenerica.DisponiFromListIndex(Allarme.MODULO),
                                                               VALORE: TSchedaGenerica.DisponiFromDouble(Allarme.VALORE, Decimali)}]})
            }
          }

          ObjCatena.MouseOverOnCoords = {}
          ObjCatena.DimensioniRelative =  {
                                            POS_X : TSchedaGenerica.DisponiFromDouble(Catena.GRAPH_POS_X, 5),
                                            POS_Y : TSchedaGenerica.DisponiFromDouble(Catena.GRAPH_POS_Y, 5),
                                            LARGHEZZA : TSchedaGenerica.DisponiFromDouble(Catena.GRAPH_LARGHEZZA, 5),
                                            ALTEZZA   : TSchedaGenerica.DisponiFromDouble(Catena.GRAPH_ALTEZZA, 5)
                                          }
          ObjCatena.MouseInfo.Coordinates = {x: 0, y: 0}
          ObjCatena.MouseInfo.Detail =  {
                                          xStart  : 0,
                                          yStart  : 0,
                                          xAngolo : 0,
                                          yAngolo : 0, 
                                          width   : 0, 
                                          height  : 0
                                        }
          ObjCatena.MouseInfo.Enlarge = {
                                          xStart : 0,
                                          yStart : 0,
                                        }
          ObjCatena.MouseInfo.Indice = TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_ORDINAMENTO)
          ObjCatena.MouseInfo.MouseDown = false
          ObjCatena.MouseInfo.MouseDownEnlarge = false
          Site.DatiCatene.push(ObjCatena)
          let MouseInfoPlaceholder = []
          MouseInfoPlaceholder.Coordinates = {x: 0, y: 0}
          MouseInfoPlaceholder.Detail =  {
                                          xStart  : 0,
                                          yStart  : 0,
                                          xAngolo : 0,
                                          yAngolo : 0, 
                                          radius  : 0,
                                          width   : 0,
                                          height  : 0
                                        }

          const Encoder = new TextEncoder();
          const ArrayByteIcona = Encoder.encode(ObjIconaAllarme.IconaAllarme);
          const ArrayInBase64 = this.ConvertiArrayUInt8InBase64(ArrayByteIcona);
          
          MouseInfoPlaceholder.Indice = TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_ORDINAMENTO)
          MouseInfoPlaceholder.MouseDown = false    
          
          const AllarmiCheck = {
                                 Inclinometro  : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_INCLINOMETRO),
                                 Sghembo       : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_SGHEMBO),
                                 Piezometro    : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_PIEZOMETRO),
                                 Estensimetro  : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_ESTENSIMETRO),
                                 Temperatura   : TSchedaGenerica.DisponiFromBoolean(Catena.CFG_TEMPERATURA),
                                 Accelerometro : TSchedaGenerica.DisponiFromInteger(Catena.CFG_ACCELEROMETRO)
                               };
          const IconaAllarme = this.AllarmiVisibili(AllarmiCheck, ObjCatena.TipiAllarmiAttivi) ? 'data:image/svg+xml;base64,' + ArrayInBase64 : 'Pallino';
  
          MouseInfoPlaceholder.MouseDown = false               
          this.PlaceholderArray.push(new TPlaceholder( TSchedaGenerica.DisponiFromListIndex(Catena.CHIAVE),
                                                       TSchedaGenerica.DisponiFromDouble(Catena.PLACEHOLDER_POS_X, 5) ? TSchedaGenerica.DisponiFromDouble(Catena.PLACEHOLDER_POS_X, 5) : ObjCatena.DimensioniRelative.POS_X + ObjCatena.DimensioniRelative.LARGHEZZA / 2,
                                                       TSchedaGenerica.DisponiFromDouble(Catena.PLACEHOLDER_POS_Y, 5) ? TSchedaGenerica.DisponiFromDouble(Catena.PLACEHOLDER_POS_Y, 5) : ObjCatena.DimensioniRelative.POS_Y + ObjCatena.DimensioniRelative.ALTEZZA / 2,
                                                       TSchedaGenerica.DisponiFromInteger(Catena.GRAPH_PLACEHOLDER_DIM),
                                                       TSchedaGenerica.DisponiFromBoolean(Catena.FUORI_SERVIZIO),
                                                       MouseInfoPlaceholder,
                                                       TSchedaGenerica.DisponiFromString(Catena.DESCRIZIONE),
                                                       TSchedaGenerica.DisponiFromInteger(Catena.PLACEHOLDER_TITLE_SIZE),
                                                       TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_TITLE_COLOR),
                                                       TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_TEXT_POSITION),
                                                       TSchedaGenerica.DisponiFromBoolean(Catena.CFG_INCLINOMETRO),
                                                       TSchedaGenerica.DisponiFromBoolean(Catena.CFG_SGHEMBO),
                                                       TSchedaGenerica.DisponiFromBoolean(Catena.CFG_PIEZOMETRO),
                                                       TSchedaGenerica.DisponiFromBoolean(Catena.CFG_ESTENSIMETRO),
                                                       TSchedaGenerica.DisponiFromBoolean(Catena.CFG_TEMPERATURA),
                                                       TSchedaGenerica.DisponiFromInteger(Catena.CFG_ACCELEROMETRO),
                                                       TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_ALARM_COLOR),
                                                       TSchedaGenerica.DisponiFromString(Catena.PLACEHOLDER_ALARM_EMPTY_CL),
                                                       false,
                                                       IconaAllarme,
                                                       ObjCatena.DatiCatena.CatenaSoloPiezo))
          TTools.AdattaScaleGrafici([ObjCatena], ValoreMassimoGrafico, ValoreMassimoGrafico, false)
        }

        let SitoSoloMeteo = Site.DatiCatene.every(el => el.DatiCatena.CatenaSoloMeteo)

        if(SitoSoloMeteo && Catene.length > 0)
        {
          this.IsSitoMostraSoloMeteo = true
          this.MostraGrafici         = false
          this.MostraIconaAllarme    = true
        }
        else
        {
          this.IsSitoMostraSoloMeteo = false
          this.MostraGrafici         = true
        }
          
        Site.DatiCatene.sort(function(a,b)
                             {
                               if (a.Indice > b.Indice)
                                 return 1
                               return -1
                             }) 

        this.SetSameDimensionToAllGraph(Site)
        // TTools.AdattaScaleGrafici(Site.DatiCatene, MaxMinGraph, MaxMinGraph, false)
      },

      SetSameDimensionToAllGraph(Site)
      {
        let MaxYAllCatene     = 0
        let MaxNotchAllCatene = 0
        Site.DatiCatene.forEach((Catena) => { 
                                              if(Catena.DatiGrafici.GRAPH_AUTO_SCALE)
                                              {
                                                if(MaxYAllCatene <= Catena.DatiGrafici.Polare.Max)
                                                {
                                                  MaxYAllCatene     = Math.max(MaxYAllCatene, Catena.DatiGrafici.Polare.Max)
                                                  MaxNotchAllCatene = Math.max(MaxNotchAllCatene, Catena.DatiGrafici.Polare.Udm)
                                                }
                                              }
                                              else 
                                              {
                                                if(MaxYAllCatene <= MaxYAllCatene)
                                                {
                                                  MaxYAllCatene     = Math.max(MaxYAllCatene, Catena.DatiGrafici.AXES_MAX)
                                                  MaxNotchAllCatene = Math.max(MaxNotchAllCatene, Catena.DatiGrafici.NOTCH_SIZE)
                                                }
                                              }
                                            })

        Site.DatiCatene.forEach((Catena) => { 
                                              Catena.DatiGrafici.AXES_MAX_CALCOLATO = MaxYAllCatene 
                                              Catena.DatiGrafici.NOTCH_SIZE         = MaxNotchAllCatene
                                            })  
      },

      ConvertiArrayUInt8InBase64(ArrayUInt8)
      {
        let StringaDiByte = '';

        ArrayUInt8.forEach(byte => StringaDiByte += String.fromCharCode(byte));
        return window.btoa(StringaDiByte);
      },

      LoadImmagineFromFile()
      {
        let Self = this
        let Reader  = new FileReader()
        let ImgFile = document.getElementById('InputImmagineMod')
        
        Reader.readAsDataURL(ImgFile.files[0])

        Reader.onload = function (e) 
        {
          var Img = new Image()
          Img.onload = function () 
          {
            Img.onload = undefined;
            Self.CatenaSelezionata.DatiGenerali.IMMAGINE_CATENA = Img.src
          }
          Img.src = e.target.result
        } 
      },

      AggiungiNuovoGrafico(Giorni)
      {
        this.CaricamentoDatiSiti = true
        let Parametri = {Chiave : this.SitoSelezionato.CHIAVE, Date : [], GetGraphsOnly : true}
        if (Giorni != null)
        {
          this.NuovaDataGrafico = TZDateFunct.ChangeDate(new Date(this.UltimaData), 'day', -1 * Giorni)
          this.NuovaOraGrafico  = TZDateFunct.FormatDateTime('hh:nn', this.NuovaDataGrafico)
          this.NuovaDataGrafico = TZDateFunct.FormatDateTime('yyyy-mm-dd', this.NuovaDataGrafico)
        }
        for (let i = 0; i < this.ListaGrafici.length; i++)
        {
          if (this.ListaGrafici[i].Data == this.NuovaDataGrafico + ' ' + this.NuovaOraGrafico)
          {
            this.TestoPopupData = this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_GRAF_PRESENTE',this.LinguaUtente)
            this.PopupAvvisoData = true
            return
          }
          Parametri.Date.push(this.ListaGrafici[i].Data)
        }
        if (this.NuovaDataGrafico != null)
          Parametri.Date.push(this.NuovaDataGrafico + ' ' + this.NuovaOraGrafico)
        this.TrovaCampioniAbbinamentoPerData(Parametri,
                                            () =>
                                            {
                                              if (this.ListaOre.length > 0)
                                              {
                                                // let Orario = TZDateFunct.FormatDateTime('hh:nn', new Date(this.UltimaData))
                                                // if (this.ListaOre.includes(Orario))
                                                //   this.NuovoOraGrafico = Orario
                                                this.AggiungiDataAbbinato(Parametri)
                                              }
                                              else
                                              {
                                                this.TestoPopupData  = this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_GRAF_NON_TROVATO',this.LinguaUtente)
                                                this.PopupAvvisoData = true
                                              }
                                            })
      },

      TrovaCampioniAbbinamentoPerData(Parametri, OnSuccess)
      {
        this.ListaOre = []
        let Self = this
        let Dal = this.NuovaDataGrafico + ' 00:00:00' 
        let Al  = this.NuovaDataGrafico + ' 23:59:59'
        Parametri.Dal = Dal
        Parametri.Al = Al
        Parametri.DMSEWSito = this.SitoSelezionato.CHIAVE
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        SystemInformation.AdvQuerySiti.GetSQL("Catene",{Dal : Dal, Al : Al, DMSEWSito : this.SitoSelezionato.CHIAVE},
                                              function(Results)
                                              {
                                                let ArrayInfo = SystemInformation.AdvQuerySiti.FindResults(Results,"GetOrari");
                                                if(ArrayInfo != undefined)
                                                {
                                                  if (ArrayInfo.length > 0)
                                                  {
                                                    for (let i = 0; i < ArrayInfo.length; i++)
                                                    {
                                                      let Data = new Date(ArrayInfo[i].DATA)
                                                      let Ora = Data.getHours()
                                                      if (Ora < 10)
                                                        Ora = '0' + Ora
                                                      let Minuti = Data.getMinutes()
                                                      if (Minuti < 10)
                                                        Minuti = '0' + Minuti
                                                      Self.ListaOre.push(Ora + ':' + Minuti)
                                                    }
                                                    let UltimoOrario = TZDateFunct.FormatDateTime('hh:nn', new Date(Self.UltimaData))
                                                    if (Self.ListaOre.includes(UltimoOrario))
                                                      Self.NuovaOraGrafico = UltimoOrario                        
                                                    else
                                                      Self.NuovaOraGrafico = Self.ListaOre[0]
                                                    // Self.ObjAbbinati.DatiTrovati = true
                                                    if (OnSuccess != null)
                                                    {
                                                      OnSuccess()
                                                    }
                                                  }
                                                  else
                                                  {
                                                    Self.PopupAvvisoData = true
                                                    Self.TestoPopupData = Self.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_CAMP_NON_TROVATO',Self.LinguaUtente)
                                                  }
                                                }
                                                else SystemInformation.HandleError("Impossibile ottenere i dati della catena"); 
                                              },
                                              function(HTTPError,SubHTTPError)
                                              {
                                                SystemInformation.HandleError(HTTPError,SubHTTPError)
                                              }, 'SelectOrariAbbinamentoDashboard');
      },

      AggiungiDataAbbinato(Parametri)
      {
        let Self = this
        SystemInformation.AdvQuery.ExecuteExternalScript('ExtraDatiCatene',Parametri,
                                                          function(Answer) 
                                                          {
                                                            Self.UltimaData = null                                                              
                                                            let Colore = ''
                                                            let index  = 0
                                                            while (Colore == '')
                                                            {
                                                              if (COLORI_DEFAULT_GRAFICI.length > Self.ListaGrafici.length - COLORI_DEFAULT_GRAFICI.length * index)
                                                              {
                                                                Colore = COLORI_DEFAULT_GRAFICI[Self.ListaGrafici.length - COLORI_DEFAULT_GRAFICI.length * index]
                                                              }
                                                              index++
                                                            }
                                                            for (let i = 0; i < Answer.QueryData.length; i++)
                                                            {
                                                              let index = Self.CateneMostrate.findIndex((element) => (element.DatiCatena.CHIAVE == Answer.QueryData[i].CHIAVE))     
                                                              if (index != -1)
                                                              {
                                                                let indice = -1
                                                                let GraficoDataOra = Self.NuovaDataGrafico + ' ' + Self.NuovaOraGrafico                 
                                                                for (let j = 0; j < Answer.QueryData[i].Spostamenti.Date.length; j++)
                                                                {
                                                                  let Spostamento = Answer.QueryData[i].Spostamenti.Date[j]
                                                                  if (Self.NuovaDataGrafico != null && Spostamento.Data == GraficoDataOra)
                                                                  {
                                                                    let IndiceDataOra = Self.ListaGrafici.findIndex((element) => {return element.Data == GraficoDataOra})
                                                                    if (IndiceDataOra == -1)
                                                                    {
                                                                      let ObjGrafico = {Data: GraficoDataOra, Colore: Colore, Markup: 'CerchioPieno'}
                                                                      Self.ListaGrafici.push(ObjGrafico)
                                                                    }
                                                                  }
                                                                  if (Spostamento.Ultima)
                                                                    indice = j
                                                                  else
                                                                  {
                                                                    let ObjData = Self.ListaGrafici.find((element) => {return element.Data == Spostamento.Data})
                                                                    if (ObjData != undefined)
                                                                    {
                                                                      Spostamento.Colore = ObjData.Colore
                                                                      Spostamento.Markup = SystemInformation.GetBlobSVGMarkup(ObjData.Markup, ObjData.Colore, Answer.QueryData[i].GRAPH_MARKUP_WIDTH)
                                                                      Spostamento.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup(ObjData.Markup, 'red', Answer.QueryData[i].GRAPH_MARKUP_WIDTH)                                                                      
                                                                    }
                                                                  }
                                                                }
                                                                if (indice != -1 && (Self.UltimaData == null || Self.UltimaData < Answer.QueryData[i].Spostamenti.Date[indice].Data))
                                                                  Self.UltimaData = Answer.QueryData[i].Spostamenti.Date[indice].Data
                                                                if (indice != -1)
                                                                {
                                                                  if (Self.MostraUltimoGrafico)
                                                                    Self.CateneMostrate[index].DatiCatena.Spostamenti = Answer.QueryData[i].Spostamenti
                                                                  else              
                                                                    Answer.QueryData[i].Spostamenti.Date.splice(indice, 1)
                                                                } 
                                                              }
                                                            }
                                                            Self.GraficiChange++
                                                            Self.AnnullaAggiuntaGrafico()
                                                          },
        function(ErrorMessage,DescrErrore)
        {
          Self.CaricamentoDatiSiti = false
          alert(ErrorMessage + '[' + DescrErrore + ']')
        })
      },

      ConfermaNuovaDataAbbinato()
      {
        this.PopupSelezioneNuovaData = false
        this.CaricamentoDatiSiti = true
        let Parametri = {Chiave : this.SitoSelezionato.CHIAVE, Date : [], GetGraphsOnly : true}
        for (let i = 0; i < this.ListaGrafici.length; i++)
        {
          if (this.ListaGrafici[i].Data == this.NuovaDataGrafico + ' ' + this.NuovaOraGrafico)
          {
            this.TestoPopupData = this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_GRAF_PRESENTE',this.LinguaUtente)
            this.PopupAvvisoData = true
            return
          }
          Parametri.Date.push(this.ListaGrafici[i].Data)
        }
        Parametri.Date.push(this.NuovaDataGrafico + ' ' + this.NuovaOraGrafico)
        this.AggiungiDataAbbinato(Parametri)
      },

      // AggiungiNuovoGrafico(Giorni = null)
      // {
      //   let Self = this
      //   let Parametri = {Chiave : this.SitoSelezionato.CHIAVE, Date : [], GetGraphsOnly : true}
      //   let DataGiaPresente = false        
      //   if (Giorni != null)
      //   {
      //     this.NuovaDataGrafico = TZDateFunct.ChangeDate(new Date(this.UltimaData), 'day', -1 * Giorni)
      //     this.NuovaOraGrafico  = this.NuovaDataGrafico.getHours()
      //     this.NuovaDataGrafico = TZDateFunct.FormatDateTime('yyyy-mm-dd', this.NuovaDataGrafico)
      //   }
      //   if (this.NuovaDataGrafico != null)
      //   {
      //     this.NuovaDataGrafico = TZDateFunct.ChangeDate(new Date(this.NuovaDataGrafico), 'hour', this.NuovaOraGrafico)
      //     this.NuovaDataGrafico = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn:ss', this.NuovaDataGrafico)
      //   }
      //   for (let i = 0; i < this.ListaGrafici.length; i++)
      //   {
      //     if (this.ListaGrafici[i].Data == this.NuovaDataGrafico)
      //     {
      //       DataGiaPresente = true
      //       break
      //     }
      //     Parametri.Date.push(this.ListaGrafici[i].Data)
      //   }
      //   if (this.NuovaDataGrafico != null)
      //     Parametri.Date.push(this.NuovaDataGrafico)
      //   if (!DataGiaPresente)
      //   {
      //     SystemInformation.AdvQuery.ExecuteExternalScript('ExtraDatiCatene',Parametri,
      //                                                       function(Answer) 
      //                                                       {
      //                                                         Self.UltimaData = null                                                              
      //                                                         let Colore = ''
      //                                                         let index  = 0
      //                                                         while (Colore == '')
      //                                                         {
      //                                                           if (COLORI_DEFAULT_GRAFICI.length > Self.ListaGrafici.length - COLORI_DEFAULT_GRAFICI.length * index)
      //                                                           {
      //                                                             Colore = COLORI_DEFAULT_GRAFICI[Self.ListaGrafici.length - COLORI_DEFAULT_GRAFICI.length * index]
      //                                                           }
      //                                                           index++
      //                                                         }
      //                                                         let NuovaDataTrovata = false
      //                                                         for (let i = 0; i < Answer.QueryData.length; i++)
      //                                                         {
      //                                                           let index = Self.CateneMostrate.findIndex((element) => (element.DatiCatena.CHIAVE == Answer.QueryData[i].CHIAVE))     
      //                                                           if (index != -1)
      //                                                           {
      //                                                             let indice = -1                                                                  
      //                                                             for (let j = 0; j < Answer.QueryData[i].Spostamenti.Date.length; j++)
      //                                                             {
      //                                                               let Spostamento = Answer.QueryData[i].Spostamenti.Date[j]
      //                                                               if (Self.NuovaDataGrafico != null && Spostamento.Data == Self.NuovaDataGrafico)
      //                                                               {
      //                                                                 NuovaDataTrovata = true
      //                                                                 Self.ListaGrafici.push({Data: Self.NuovaDataGrafico, Colore: Colore, Markup: 'CerchioPieno'})
      //                                                               }
      //                                                               if (Spostamento.Ultima)
      //                                                                 indice = j
      //                                                               else
      //                                                               {
      //                                                                 let ObjData = Self.ListaGrafici.find((element) => (element.Data == Spostamento.Data))
      //                                                                 Spostamento.Colore = ObjData.Colore
      //                                                                 Spostamento.Markup = SystemInformation.GetBlobSVGMarkup(ObjData.Markup, ObjData.Colore, Answer.QueryData[i].GRAPH_MARKUP_WIDTH)
      //                                                                 Spostamento.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup(ObjData.Markup, 'red', Answer.QueryData[i].GRAPH_MARKUP_WIDTH)
      //                                                               }
      //                                                             }
      //                                                             if (indice != -1 && (Self.UltimaData == null || Self.UltimaData < Answer.QueryData[i].Spostamenti.Date[indice].Data))
      //                                                               Self.UltimaData = Answer.QueryData[i].Spostamenti.Date[indice].Data
      //                                                             if (indice != -1)
      //                                                             {
      //                                                               if (Self.MostraUltimoGrafico)
      //                                                                 Self.CateneMostrate[index].DatiCatena.Spostamenti = Answer.QueryData[i].Spostamenti
      //                                                               else              
      //                                                                 Answer.QueryData[i].Spostamenti.Date.splice(indice, 1)
      //                                                             } 
      //                                                           }
      //                                                         }
      //                                                         if (!NuovaDataTrovata)
      //                                                         {
      //                                                           Self.TestoPopupData = 'Nessun grafico trovato per la data selezionata'
      //                                                           Self.PopupAvvisoData = true
      //                                                         }
      //                                                         Self.GraficiChange++
      //                                                         Self.AnnullaAggiuntaGrafico()
      //                                                       },
      //     function(ErrorMessage,DescrErrore)
      //     {
      //       alert(ErrorMessage + '[' + DescrErrore + ']')
      //     })
      //   }
      //   else
      //   {
      //     this.TestoPopupData = 'È già presente un grafico per la data inserita'
      //     this.PopupAvvisoData = true
      //     this.AnnullaAggiuntaGrafico()
      //   }
      // },

      AnnullaAggiuntaGrafico()
      {
        this.PopupSelezioneNuovaData = false
        this.ListaOre = []
        this.NuovaDataGrafico = null
        this.NuovaOraGrafico = null
        this.CaricamentoDatiSiti = false
      },

      CambiaColoreGrafico(Grafico)
      {
        this.GraficoSelezionato = Grafico
        this.ColoreInModifica.Colore = Grafico.Colore
        this.PopupColorPicker   = true
      },

      LoadAllSite(OnSuccess)
      {
        this.ListaSiti = SystemInformation.Configurazioni.Siti
        if (OnSuccess != undefined)
          OnSuccess()
      },

      DisattivaAttivaCatena(Catena)
      {
        Catena.FUORI_SERVIZIO = !Catena.FUORI_SERVIZIO
        if (this.Admin)
        {
          let ObjQuery = {Operazioni : []}
          let ObjCatena = {Query : 'CambiaFuoriServizio', Parametri: {}}
          ObjCatena.Parametri = {CHIAVE : Catena.CHIAVE, FUORI_SERVIZIO : TSchedaGenerica.PrepareForRecordBoolean(Catena.FUORI_SERVIZIO)} 
          ObjQuery.Operazioni.push(ObjCatena)
          SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
          SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                            function()
                                                            {
                                                            },
                                                            function(HTTPError,SubHTTPError,Response)
                                                            {
                                                              SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                            },
                                                            false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
        }
        setTimeout(this.DrawMap, 1)
      },

      ToggleMostraUltimoGrafico()
      {
        
      },

      SegnaComeEliminato()
      {
        let Self = this
        let ChiaveCatena = this.CatenaDaEliminare.CHIAVE
        let ObjQuery = {Operazioni : []}
        let ObjCatena = {Query : 'Delete', Parametri: {}}
        ObjCatena.Parametri = {CHIAVE : ChiaveCatena} 
        ObjQuery.Operazioni.push(ObjCatena)
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                          function()
                                                          {
                                                            Self.AnnullaEliminazione()
                                                            let index = Self.SitoSelezionato.DatiCatene.findIndex(element=>(element.DatiCatena.CHIAVE == ChiaveCatena))
                                                            if (index == -1)
                                                              throw new Error(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_ERR_ELIM_CATENA',this.LinguaUtente))
                                                            Self.SitoSelezionato.DatiCatene.splice(index, 1)
                                                            index = Self.PlaceholderArray.findIndex(element=>(element.Chiave == ChiaveCatena))
                                                            if (index == -1)
                                                              throw new Error(this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_ERR_ELIM_PLACEHOLDER',this.LinguaUtente))
                                                            Self.PlaceholderArray.splice(index, 1)
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          },
                                                          false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
      },

      AnnullaEliminazione()
      {
        this.CatenaDaEliminare = null
        this.PopupEliminazione = false
      },

      RimuoviAllineamento()
      {
        this.ObjAllineamento.DataAllineamento = null
        this.ObjAllineamento.OrarioAllineamento = null
        this.ObjAllineamento.ListaOre = []
        this.ObjAllineamento.DataOraAllineamento = null
      },

      ConfermaRicerca(ChiaveSito)
      {
        this.RimuoviAllineamento()
        this.LoadSite(this.ListaSiti.find(element=>(element.CHIAVE == ChiaveSito)))
      },
      
      InserisciData(IntervalloTemp)
      {
        let Now = new Date();
        let DataScelta = new Date(Now.getTime() - IntervalloTemp);

        let Anno = DataScelta.getFullYear();
        let Giorno = String(DataScelta.getDate()).padStart(2, '0');
        let Mese = String(DataScelta.getMonth() + 1).padStart(2, '0');
        this.OraPreimpostata = String(DataScelta.getHours()).padStart(2, '0');
        let DataStringa = `${Anno}-${Mese}-${Giorno}`;
        this.ObjAllineamento.DataAllineamento = DataStringa

        this.TrovaCampioniPerData(this.InserisciOre)
      },

      InserisciOre()
      {
        this.ObjAllineamento.OrarioAllineamento = this.OraPreimpostata + ':00'
      },

      TrovaCampioniPerData(OnSuccess = undefined)
      {
        if (!this.Loading)
        {
          this.Loading = true
          this.ObjAllineamento.ListaOre = []
          let Self = this
          let Dal = this.ObjAllineamento.DataAllineamento + ' 00:00:00' 
          let Al  = this.ObjAllineamento.DataAllineamento + ' 23:59:59'
          SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
          SystemInformation.AdvQuerySiti.GetSQL("Catene",{Dal : Dal, Al : Al, DMSEWSito : this.SitoSelezionato.CHIAVE},
                                                function(Results)
                                                {
                                                  let ArrayInfo = SystemInformation.AdvQuerySiti.FindResults(Results,"GetOrariAll");
                                                  if(ArrayInfo != undefined)
                                                  {
                                                    Self.ObjAllineamento.DatiTrovati = false
                                                    if (ArrayInfo.length > 0)
                                                    {
                                                      for (let i = 0; i < ArrayInfo.length; i++)
                                                      {
                                                        let Data = new Date(ArrayInfo[i].DATA)
                                                        let Ora = Data.getHours()
                                                        if (Ora < 10)
                                                          Ora = '0' + Ora
                                                        let Minuti = Data.getMinutes()
                                                        if (Minuti < 10)
                                                          Minuti = '0' + Minuti
                                                        Self.ObjAllineamento.ListaOre.push(Ora + ':' + Minuti)
                                                      }
                                                      if (Self.ObjAllineamento.ListaOre.length > 0)
                                                      {
                                                        Self.ObjAllineamento.OrarioAllineamento = Self.ObjAllineamento.ListaOre[0]
                                                        Self.ObjAllineamento.DatiTrovati = true 
                                                      }
                                                      if (OnSuccess != null)
                                                      {
                                                        OnSuccess()
                                                      }
                                                    }
                                                    Self.Loading = false
                                                  }
                                                  else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
                                                },
                                                function(HTTPError,SubHTTPError)
                                                {
                                                  SystemInformation.HandleError(HTTPError,SubHTTPError)
                                                }, 'SelectOrariAllineamento');
        }
      },

      AnnullaAllineamento()
      {
        this.MenuTrigger.TriggerAllineaPolari = 0
        this.PopupSelezioneAllineamento = false
        this.ObjAllineamento.DataAllineamento = null
        this.ObjAllineamento.OrarioAllineamento = null
        this.ObjAllineamento.ListaOre = []
        this.ObjAllineamento.DataOraAllineamento = null
        this.TempGraphicDetails = null
      },

      ConfermaAllineamento()
      {
        this.ObjAllineamento.DataOraAllineamento = this.ObjAllineamento.DataAllineamento + ' ' + this.ObjAllineamento.OrarioAllineamento
        this.LoadSite(this.SitoSelezionato)
        this.PopupSelezioneAllineamento = false
      },

      CambiaSitoAvanti()
      {
        this.RimuoviAllineamento()
        let index = this.ListaSiti.findIndex(element=>(element.CHIAVE == this.SitoSelezionato.CHIAVE)) + 1
        if (index > this.ListaSiti.length - 1)
          index = 0
        this.LoadSite(this.ListaSiti[index])
      },

      CambiaSitoIndietro()
      {
        this.RimuoviAllineamento()
        let index = this.ListaSiti.findIndex(element=>(element.CHIAVE == this.SitoSelezionato.CHIAVE)) - 1
        if (index < 0)
          index = this.ListaSiti.length - 1
        this.LoadSite(this.ListaSiti[index])
      },

      ApriMenuCatene()
      {
        this.MenuCateneAperto = true
      },

      ApriMenuGraficiAbbinati()
      {
        this.MenuGraficiAbbinatiAperto = true
      },

      ToggleDataAllineamento()
      {
        this.TempGraphicDetails = {dx : this.GraphicDetails.dx, dy : this.GraphicDetails.dy, Zoom : this.GraphicDetails.Zoom}
        if (this.ObjAllineamento.DataOraAllineamento != null)
        {
          this.ObjAllineamento.DataAllineamento = null
          this.ObjAllineamento.OrarioAllineamento = null
          this.ObjAllineamento.ListaOre = []
          this.ObjAllineamento.DataOraAllineamento = null
          this.LoadSite(this.SitoSelezionato)
        }
        else
        {
          this.PopupSelezioneAllineamento = true
        }
      },

      ToggleMostraGrafici()
      {
        this.MostraGrafici = !this.MostraGrafici;
        this.MostraIconaAllarme = true;
      },

      ApriPopupDatiGeneraliCatena(ChiaveCatena, ChiaveSito)
      {
        let Catena = this.SitoSelezionato.DatiCatene.find(element => (element.DatiCatena.CHIAVE == ChiaveCatena))
        this.CatenaSelezionata = new TCatena(ChiaveCatena, ChiaveSito, Catena.Moduli, this.GetTraduzioneLabel, this.LinguaUtente, Catena.Piezometro, Catena.Packer)
        this.TitoloPopupCatena = this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_MOD_CATENA',this.LinguaUtente) + ' [' + Catena.DatiCatena.DESCRIZIONE + ']' 
        this.CatenaSelezionata.Disponi(()=>{this.PopupCatenaGenerale = true})
      },

      AggiungiNuovaCatena()
      {
        this.CatenaSelezionata = new TCatena(-1, this.SitoSelezionato.CHIAVE, [], this.GetTraduzioneLabel, this.LinguaUtente)
        this.TitoloPopupCatena = this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_NEW_CATENA',this.LinguaUtente)
        this.PopupCatenaGenerale = true
      },

      ApriPopupEliminazione(Catena)
      {
        this.CatenaDaEliminare = Catena
        this.TestoPopupEliminazione = this.GetTraduzioneLabel('VUEAppContentDashboard','TKN_APP_CON_DASH_POPUP_DEL_CATENA',this.LinguaUtente) + ' ' + this.CatenaDaEliminare.DESCRIZIONE + '?'
        this.PopupEliminazione = true
      },

      AnnullaModificaGenerale()
      {
        this.PopupCatenaGenerale = false
        this.CatenaSelezionata = null
        this.ProfonditaImpostata = 0
        this.LoadSite(this.SitoSelezionato)
      },

      ConfermaModificaGenerale()
      {
        let Self = this 
        this.CatenaSelezionata.RegistraDatiGenerali(function()
                                                    {
                                                      Self.PopupCatenaGenerale = false     
                                                      Self.CatenaSelezionata = null
                                                      Self.ProfonditaImpostata = 0
                                                      Self.LoadSite(Self.SitoSelezionato)
                                                    })
      },

      ApriPopupDimPlaceholder()
      {
        this.NewDimPlaceholder = this.SitoSelezionato.DatiCatene[0].DatiGrafici.PLACEHOLDER_DIM
        this.PopupDimPlaceholder = true
      },

      AnnullaPopupDimPlaceholder()
      {
        this.PopupDimPlaceholder = false
      },

      ConfermaPopupDimPlaceholder()
      {
        let Self = this
        let ObjQuery = {Operazioni : []}
        let ObjCatena = {Query : 'UpdatePlaceholderDim', Parametri: {}}
        ObjCatena.Parametri = {
                                NEW_DIM : TSchedaGenerica.PrepareForRecordInteger(this.NewDimPlaceholder),
                              }
        ObjQuery.Operazioni.push(ObjCatena)        
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                          function()
                                                          {
                                                            Self.LoadSite(Self.SitoSelezionato)                                                           
                                                            Self.AnnullaPopupDimPlaceholder()                                               
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          },
                                                          false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
      },

      ApriPopupModifica()
      {        
        let Self = this
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId

        SystemInformation.AdvQuerySiti.GetSQL('Catene', { DMSEWSito: this.SitoSelezionato.CHIAVE},
                                              function(Results)
                                              {
                                                let ArrayCatena = (SystemInformation.AdvQuerySiti.FindResults(Results,'SelectAllCatene'))
                                                if (ArrayCatena != undefined)
                                                {
                                                  let GraphStdConfig = null

                                                  for (let i = 0; i < ArrayCatena.length; i++) 
                                                  {
                                                    let Catena = ArrayCatena[i]
                                                    if(Catena.ELIMINATO == 'F')
                                                    {
                                                      GraphStdConfig = ArrayCatena[0]                                                      
                                                    }
                                                  }
                                                  
                                                  if(GraphStdConfig != null)
                                                  {
                                                    Self.ObjGrafica.TitleColor          = TSchedaGenerica.DisponiFromString(GraphStdConfig.GRAPH_TITLE_COLOR)
                                                    Self.ObjGrafica.TitleFontSize       = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_TITLE_FONT_SIZE)
                                                    Self.ObjGrafica.Background          = TSchedaGenerica.DisponiFromString(GraphStdConfig.GRAPH_BACKGROUND)
                                                    Self.ObjGrafica.Color               = TSchedaGenerica.DisponiFromString(GraphStdConfig.GRAPH_COLOR)
                                                    Self.ObjGrafica.MarkupScelto        = TSchedaGenerica.DisponiFromString(GraphStdConfig.GRAPH_MARKUP)
                                                    Self.ObjGrafica.MarkupWidth         = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_MARKUP_WIDTH)
                                                    Self.ObjGrafica.PenWidth            = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_PEN_WIDTH)
                                                    Self.ObjGrafica.DrawBorders         = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.GRAPH_DRAW_BORDERS)
                                                    Self.ObjGrafica.DrawTitleStroke     = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.GRAPH_DRAW_TITLE_STROKE)
                                                    Self.ObjGrafica.AutoScale           = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.GRAPH_AUTO_SCALE)
                                                    Self.ObjGrafica.ColorTitleStroke    = TSchedaGenerica.DisponiFromString(GraphStdConfig.GRAPH_COLOR_TITLE_STROKE)
                                                    Self.ObjGrafica.PlaceholderDim      = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_PLACEHOLDER_DIM)
                                                    Self.ObjGrafica.SizePlaceholder     = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.PLACEHOLDER_TITLE_SIZE)
                                                    Self.ObjGrafica.ColorPlaceholder    = TSchedaGenerica.DisponiFromString(GraphStdConfig.PLACEHOLDER_TITLE_COLOR)
                                                    Self.ObjGrafica.PositionPlaceholder = TSchedaGenerica.DisponiFromString(GraphStdConfig.PLACEHOLDER_TEXT_POSITION)
                                                    Self.ObjGrafica.CfgInclinometro     = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.CFG_INCLINOMETRO)
                                                    Self.ObjGrafica.CfgSghembo          = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.CFG_SGHEMBO)
                                                    Self.ObjGrafica.CfgPiezometro       = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.CFG_PIEZOMETRO)
                                                    Self.ObjGrafica.CfgEstensimetro     = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.CFG_ESTENSIMETRO)
                                                    Self.ObjGrafica.CfgTemperatura      = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.CFG_TEMPERATURA)
                                                    Self.ObjGrafica.CfgAccelerometro    = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.CFG_ACCELEROMETRO)
                                                    Self.ObjGrafica.ColorAlarmPh        = TSchedaGenerica.DisponiFromString(GraphStdConfig.PLACEHOLDER_ALARM_COLOR)
                                                    Self.ObjGrafica.ColorAlarmEmpty     = TSchedaGenerica.DisponiFromString(GraphStdConfig.PLACEHOLDER_ALARM_EMPTY_CL)

                                                    let AsseX = Self.ObjGrafica.AxisX

                                                    AsseX.Min             = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_MAX * -1)
                                                    AsseX.Max             = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_MAX)
                                                    AsseX.MaxReale        = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_MAX)
                                                    AsseX.NotchDim        = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_NOTCH_SIZE)
                                                    AsseX.Color           = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_AXES_COLOR)
                                                    AsseX.PenWidth        = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_PEN_WIDTH)
                                                    AsseX.NotchColor      = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_AXES_NOTCH_COLOR)
                                                    AsseX.NotchFontSize   = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_NOTCH_FONT_SIZE)
                                                    AsseX.NotchPenWidth   = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_NOTCH_PEN_WIDTH)
                                                    AsseX.FontSize        = TSchedaGenerica.DisponiFromInteger(GraphStdConfig.GRAPH_AXES_FONT_SIZE)
                                                    AsseX.FontColor       = TSchedaGenerica.PrepareForRecordString(GraphStdConfig.GRAPH_AXES_FONT_COLOR)
                                                    AsseX.FontWeight      = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.GRAPH_AXES_LABELS_USE_BOLD) ? "bolder" : "normal"
                                                    AsseX.DrawLabels      = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.GRAPH_DRAW_LATERAL_LABELS)
                                                    AsseX.DrawNotchLabels = TSchedaGenerica.DisponiFromBoolean(GraphStdConfig.GRAPH_DRAW_NOTCH_LABELS)
                                                  }

                                                  Self.PopupGraficaAllCatene = true

                                                }
                                                else SystemInformation.HandleError("Impossibile ottenere i dati delle catene");
                                              },
                                              function(HTTPError,SubHTTPError,Response)
                                              {
                                                SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                              },
                                              'SelectDettaglioCatena')
      },

      ApriPopupCambiaColoriGrafici()
      {
        let Self = this
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId

        SystemInformation.AdvQuerySiti.GetSQL('Catene', { DMSEWSito: this.SitoSelezionato.CHIAVE},
                                              function(Results)
                                              {
                                                let ArrayCatena = (SystemInformation.AdvQuerySiti.FindResults(Results,'SelectAllCatene'))
                                                if (ArrayCatena != undefined)
                                                {
                                                  let GraphStdConfig = null

                                                  for (let i = 0; i < ArrayCatena.length; i++) 
                                                  {
                                                    let Catena = ArrayCatena[i]
                                                    if(Catena.ELIMINATO == 'F')
                                                    {
                                                      GraphStdConfig = ArrayCatena[0]                                                      
                                                    }
                                                  }
                                                  
                                                  if(GraphStdConfig != null)
                                                  {
                                                    Self.ObjGraficaColori.ColorePrincipale = TSchedaGenerica.DisponiFromString(GraphStdConfig.GRAPH_COLOR)
                                                    Self.ObjGraficaColori.Background       = TSchedaGenerica.DisponiFromString(GraphStdConfig.GRAPH_BACKGROUND)
                                                  }

                                                  Self.PopupGraficaColoriAllCatene = true

                                                }
                                                else SystemInformation.HandleError("Impossibile ottenere i dati delle catene");
                                              },
                                              function(HTTPError,SubHTTPError,Response)
                                              {
                                                SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                              },
                                              'SelectDettaglioCatena')
      },

      VaiACatena(Catena)
      {
        this.VaiAGraficiVerticali({ Chiave: Catena.DatiCatena.CHIAVE })
      },

      VaiAGraficiVerticali(Placeholder)
      {
        for (let i = 0; i < this.SitoSelezionato.DatiCatene.length; i++)
        {
          let Catena = this.SitoSelezionato.DatiCatene[i]

          /*let AllarmiPresenti = false
          let CatenaTrovata = this.CateneMostrate.find(CurrentCatena => CurrentCatena.DatiCatena.CHIAVE == Catena.DatiCatena.CHIAVE)
          if (CatenaTrovata)
          {            
            let AllarmiCheck =  {
                                  Inclinometro  : CatenaTrovata.DatiGrafici.CFG_INCLINOMETRO,
                                  Sghembo       : CatenaTrovata.DatiGrafici.CFG_SGHEMBO,
                                  Piezometro    : CatenaTrovata.DatiGrafici.CFG_PIEZOMETRO,
                                  Estensimetro  : CatenaTrovata.DatiGrafici.CFG_ESTENSIMETRO,
                                  Temperatura   : CatenaTrovata.DatiGrafici.CFG_TEMPERATURA,
                                  Accelerometro : CatenaTrovata.DatiGrafici.CFG_ACCELEROMETRO
                                };
            AllarmiPresenti = this.AllarmiVisibili(AllarmiCheck, CatenaTrovata.TipiAllarmiAttivi)
          }*/

          if(Catena.DatiCatena.CHIAVE == Placeholder.Chiave)
          {
            let URL = this.URLSchedaVerticali + 'ChiaveCatena=' + Catena.DatiCatena.CHIAVE + '&ChiaveSito=' + Catena.DatiCatena.CHIAVE_SITO + '&Estensimetri=' + Catena.EstensimetroPresente + '&Accelerometri=' + Catena.DatiCatena.NR_ACCELEROMETRI + '&MostraMeteo=' + (Catena.DatiCatena.ANEMOMETRO || Catena.DatiCatena.PLUVIOMETRO || Catena.DatiCatena.TERMOMETRO)// + '&Allarmi=' + AllarmiPresenti

            if ((Catena.DatiCatena.ANEMOMETRO || Catena.DatiCatena.PLUVIOMETRO || Catena.DatiCatena.TERMOMETRO) && !Catena.DatiCatena.INCLINOMETRI)
            {     
              let ListaModuli = []

              if(Catena.Moduli.length != 0)
              {
                for(let i = 0; i < Catena.Moduli.length; i++)
                {
                  let OggettoModulo          = {}
                  OggettoModulo.Id           = Catena.Moduli[i].MODULO
                  OggettoModulo.Catena       = Catena.Moduli[i].CATENA
                  OggettoModulo.Profondita   = (Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
                  OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(Catena.Moduli[i].PIEZOMETRO)
                  OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(Catena.Moduli[i].ESTENSIMETRO)
                  OggettoModulo.Selezionato  = false   
                  OggettoModulo.MaxAdattamentoAsseYAccel = 3
                  OggettoModulo.MaxAdattamentoAsseYSpost = 3
                  OggettoModulo.MaxAdattamentoAsseYVel   = 3
                  OggettoModulo.MinAdattamentoAsseYAccel = -3
                  OggettoModulo.MinAdattamentoAsseYSpost = -3
                  OggettoModulo.MinAdattamentoAsseYVel   = -3
                  OggettoModulo.UdmYAccel                = 0.5
                  OggettoModulo.UdmYSpost                = 0.5
                  OggettoModulo.UdmYVel                  = 0.5
                  ListaModuli.push(OggettoModulo)
                }
              }
              SystemInformation.OggettoInfoGraficiStorici = new TInfoGraficiStorici(Catena.DatiCatena.CHIAVE_SITO, 
                                                                                    Catena.DatiCatena.CHIAVE,
                                                                                    Catena.DatiCatena.DESCRIZIONE,
                                                                                    TIPOLOGIA_GRAFICI_STORICI.STAZIONE_METEO,
                                                                                    ListaModuli,
                                                                                    TZDateFunct.ChangeDate(new Date(), 'day', -30), 
                                                                                    new Date(), 
                                                                                    '00:00', 
                                                                                    TZDateFunct.FormatDateTime('hh:nn', new Date),
                                                                                    false,
                                                                                    false,
                                                                                    0,
                                                                                    0)
            
              SystemInformation.OggettoInfoGraficiStorici.VisualizzaPluviometro = Catena.DatiCatena.PLUVIOMETRO
              SystemInformation.OggettoInfoGraficiStorici.VisualizzaAnemometro  = Catena.DatiCatena.ANEMOMETRO
              SystemInformation.OggettoInfoGraficiStorici.VisualizzaTermometro  = Catena.DatiCatena.TERMOMETRO
              SystemInformation.OggettoInfoGraficiStorici.VisualizzaSpostamento = false
              
              // if(this.Filtro.AllineamentoIncl != null)
                SystemInformation.OggettoInfoGraficiStorici.AllineamentoIncl     = null
              // if(this.Filtro.AllineamentoTemp != null)
                SystemInformation.OggettoInfoGraficiStorici.AllineamentoTemp     = null
              // if(this.Filtro.AllineamentoDef != null)
                SystemInformation.OggettoInfoGraficiStorici.AllineamentoDef      = null
              
              SystemInformation.OggettoInfoGraficiStorici.ListaFalde             = []
              
              SystemInformation.OggettoInfoGraficiStorici.ListaTuttiModuli       = ListaModuli

              SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena   = this.$route.fullPath
              localStorage.removeItem(LOCALSTORAGE.OggettoInfoGraficiStorici);
              localStorage.setItem(LOCALSTORAGE.OggettoInfoGraficiStorici, JSON.stringify(SystemInformation.OggettoInfoGraficiStorici))
              // window.location.hash = '/appMainWindow/GraficiStorici'
              this.$router.push('/appMainWindow/GraficiStorici')
            }
            else window.location.hash = URL
            // this.$router.push(URL)
          }
        }
      },

      ConfermaModificaColoriGrafica()
      {
        let Self      = this
        let ObjQuery  = { Operazioni : [] }
        let ObjCatena = { Query : 'UpdateGraficaColoriAll', Parametri: {} }
        
        ObjCatena.Parametri = {
                                GRAPH_TITLE_COLOR          : TSchedaGenerica.PrepareForRecordString(this.ObjGraficaColori.ColorePrincipale),
                                GRAPH_BACKGROUND           : TSchedaGenerica.PrepareForRecordString(this.ObjGraficaColori.Background),
                                GRAPH_COLOR                : TSchedaGenerica.PrepareForRecordString(this.ObjGraficaColori.ColorePrincipale),
                                GRAPH_AXES_COLOR           : TSchedaGenerica.PrepareForRecordString(this.ObjGraficaColori.ColorePrincipale),
                                GRAPH_AXES_NOTCH_COLOR     : TSchedaGenerica.PrepareForRecordString(this.ObjGraficaColori.ColorePrincipale),
                                GRAPH_AXES_FONT_COLOR      : TSchedaGenerica.PrepareForRecordString(this.ObjGraficaColori.ColorePrincipale),
                                PLACEHOLDER_TITLE_COLOR    : TSchedaGenerica.PrepareForRecordString(this.ObjGraficaColori.ColorePrincipale)
                              }
        ObjQuery.Operazioni.push(ObjCatena)

        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId

        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                              function()
                                              {
                                                Self.LoadSite(Self.SitoSelezionato)
                                                Self.AnnullaModificaColoriGrafica()
                                              },
                                              function(HTTPError,SubHTTPError,Response)
                                              {
                                                SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                              },
                                              false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
      },

      ConfermaModificaGrafica()
      {
        let Self      = this
        let ObjQuery  = { Operazioni : [] }
        let ObjCatena = { Query : 'UpdateGraficaAll', Parametri: {} }
        
        ObjCatena.Parametri = {
                                GRAPH_TITLE_COLOR          : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.TitleColor),
                                GRAPH_TITLE_FONT_SIZE      : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.TitleFontSize),
                                GRAPH_BACKGROUND           : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.Background),
                                GRAPH_DRAW_TITLE_STROKE    : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.DrawTitleStroke),
                                GRAPH_AUTO_SCALE           : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.AutoScale),
                                GRAPH_COLOR_TITLE_STROKE   : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.ColorTitleStroke),
                                GRAPH_COLOR                : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.Color),
                                GRAPH_MARKUP               : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.MarkupScelto),
                                GRAPH_MARKUP_WIDTH         : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.MarkupWidth),
                                GRAPH_PEN_WIDTH            : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.PenWidth),
                                GRAPH_DRAW_BORDERS         : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.DrawBorders),
                                GRAPH_AXES_MAX             : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.AxisX.MaxReale),
                                GRAPH_AXES_NOTCH_SIZE      : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.AxisX.NotchDim),
                                GRAPH_AXES_COLOR           : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.AxisX.Color),
                                GRAPH_AXES_PEN_WIDTH       : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.AxisX.PenWidth),
                                GRAPH_AXES_FONT_SIZE       : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.AxisX.FontSize),
                                GRAPH_AXES_FONT_COLOR      : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.AxisX.FontColor),
                                GRAPH_AXES_NOTCH_FONT_SIZE : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.AxisX.NotchFontSize),
                                GRAPH_AXES_NOTCH_COLOR     : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.AxisX.NotchColor),
                                GRAPH_AXES_NOTCH_PEN_WIDTH : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.AxisX.NotchPenWidth),
                                GRAPH_AXES_LABELS_USE_BOLD : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.AxisX.FontWeight == "bolder"),
                                GRAPH_DRAW_LATERAL_LABELS  : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.AxisX.DrawLabels),
                                GRAPH_DRAW_NOTCH_LABELS    : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.AxisX.DrawNotchLabels),
                                PLACEHOLDER_TITLE_SIZE     : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.SizePlaceholder),
                                PLACEHOLDER_TITLE_COLOR    : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.ColorPlaceholder),
                                PLACEHOLDER_TEXT_POSITION  : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.PositionPlaceholder),
                                CFG_INCLINOMETRO           : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.CfgInclinometro),
                                CFG_SGHEMBO                : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.CfgSghembo),
                                CFG_PIEZOMETRO             : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.CfgPiezometro),
                                CFG_ESTENSIMETRO           : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.CfgEstensimetro),
                                CFG_TEMPERATURA            : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGrafica.CfgTemperatura),
                                CFG_ACCELEROMETRO          : TSchedaGenerica.PrepareForRecordInteger(this.ObjGrafica.CfgAccelerometro),
                                PLACEHOLDER_ALARM_COLOR    : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.ColorAlarmPh),
                                PLACEHOLDER_ALARM_EMPTY_CL : TSchedaGenerica.PrepareForRecordString(this.ObjGrafica.ColorAlarmEmpty),
                              }
        ObjQuery.Operazioni.push(ObjCatena)

        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId

        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                              function()
                                              {
                                                Self.LoadSite(Self.SitoSelezionato)
                                                Self.AnnullaModificaGrafica()
                                              },
                                              function(HTTPError,SubHTTPError,Response)
                                              {
                                                SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                              },
                                              false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
      },

      AnnullaModificaGrafica()
      {
        this.PopupGraficaAllCatene = false
      },

      AnnullaModificaColoriGrafica()
      {
        this.PopupGraficaColoriAllCatene = false
      },

      // SEZIONE GRAFICA SFONDO
      DragImage(event)
      {
        let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
        this.GraphicDetails.dx = this.DragMode.xAngolo + (event.clientX - Coords.left) - this.DragMode.xStart
        this.GraphicDetails.dy = this.DragMode.yAngolo + (event.clientY - Coords.top) - this.DragMode.yStart        
        this.DrawMap()
      },

      DragComponent(event)
      {
        let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
        for (let i = 0; i < this.SitoSelezionato.DatiCatene.length; i++)
        {
          if (this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDown)
          {
            let PosDettaglio = this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail
            this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.x = PosDettaglio.xAngolo + (event.clientX - Coords.left) - PosDettaglio.xStart
            this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.y = PosDettaglio.yAngolo + (event.clientY - Coords.top) - PosDettaglio.yStart
          }
        }
        // let PosDettaglio = this.SitoSelezionato.DatiCatene[this.IndexCatena].MouseInfo.Detail
        // this.SitoSelezionato.DatiCatene[this.IndexCatena].MouseInfo.Coordinates.x = PosDettaglio.xAngolo + (event.clientX - Coords.left) - PosDettaglio.xStart
        // this.SitoSelezionato.DatiCatene[this.IndexCatena].MouseInfo.Coordinates.y = PosDettaglio.yAngolo + (event.clientY - Coords.top) - PosDettaglio.yStart
      },

      DragComponentPlaceholder(event)
      {
        let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
        for (let i = 0; i < this.PlaceholderMostrati.length; i++)
        {
          let Placeholder = this.PlaceholderMostrati[i]
          if (Placeholder.MouseInfoPlaceholder.MouseDown)
          {
            // let DimensioniPlaceholder = this.$refs.Placeholder
            let PosDettaglio = Placeholder.MouseInfoPlaceholder
            PosDettaglio.Coordinates.x    = (event.clientX - Coords.left) - DIM_PLACEHOLDER / 2
            PosDettaglio.Coordinates.y    = (event.clientY - Coords.top) - DIM_PLACEHOLDER / 2 
            // Placeholder.CoordPlaceholderX = ((PosDettaglio.Coordinates.x - DimensioniPlaceholder[i].clientWidth / 2 + 3/2 * Placeholder.Raggio - this.GraphicDetails.dx) / (this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom)).toFixed(5)
            // Placeholder.CoordPlaceholderY = ((PosDettaglio.Coordinates.y - DimensioniPlaceholder[i].clientHeight + Placeholder.Raggio  - this.GraphicDetails.dy) / (this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom)).toFixed(5)

            // Placeholder.CoordPlaceholderX = ((PosDettaglio.Coordinates.x - this.GraphicDetails.dx) / (this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom)).toFixed(5)
            // Placeholder.CoordPlaceholderY = ((PosDettaglio.Coordinates.y - this.GraphicDetails.dy) / (this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom)).toFixed(5)

            Placeholder.CoordPlaceholderX = ((PosDettaglio.Coordinates.x - this.GraphicDetails.dx - DIM_PLACEHOLDER * ((this.GraphicDetails.Zoom - 1) / 2)) / (this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom)).toFixed(5)
            Placeholder.CoordPlaceholderY = ((PosDettaglio.Coordinates.y - this.GraphicDetails.dy - DIM_PLACEHOLDER * ((this.GraphicDetails.Zoom - 1) / 2)) / (this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom)).toFixed(5)

            PosDettaglio.Detail           = {
                                              xStart  : PosDettaglio.Coordinates.x,
                                              yStart  : PosDettaglio.Coordinates.y,
                                              xAngolo : PosDettaglio.Coordinates.x,
                                              yAngolo : PosDettaglio.Coordinates.y, 
                                              width   : DIM_PLACEHOLDER,
                                              height  : DIM_PLACEHOLDER
                                            }
          }
        }
      },

      EnlargeComponent(event)
      {
        let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
        for (let i = 0; i < this.SitoSelezionato.DatiCatene.length; i++)
        {
          if (this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDownEnlarge)
          {
            let EnlargeDettaglio = this.SitoSelezionato.DatiCatene[i].MouseInfo.Enlarge
            this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.width = (event.clientX - Coords.left) - EnlargeDettaglio.xStart + 10
            this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.height = (event.clientY - Coords.top) - EnlargeDettaglio.yStart + 10
          }
        }
      },

      OnMouseWheel(event)
      {
        event.preventDefault();
        let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
        this.GraphicDetails.OldZoom = this.GraphicDetails.Zoom
        this.GraphicDetails.Zoom -= (event.deltaY / 50000) * SystemInformation.UserInformation.SensibilitaScroll
        this.GraphicDetails.ZoomX = event.clientX - Coords.x
        this.GraphicDetails.ZoomY = event.clientY - Coords.y

        let minZoomWheel = this.GetMinZoom()
        if (this.GraphicDetails.Zoom < minZoomWheel)
          this.GraphicDetails.Zoom = minZoomWheel
        if (this.GraphicDetails.Zoom > MAX_ZOOM)
          this.GraphicDetails.Zoom = MAX_ZOOM

        this.GraphicDetails.dx = (1 - (this.GraphicDetails.Zoom / this.GraphicDetails.OldZoom)) * (this.GraphicDetails.ZoomX - this.GraphicDetails.dx) + this.GraphicDetails.dx
        this.GraphicDetails.dy = (1 - (this.GraphicDetails.Zoom / this.GraphicDetails.OldZoom)) * (this.GraphicDetails.ZoomY - this.GraphicDetails.dy) + this.GraphicDetails.dy

        this.DragMode.xAngolo = this.GraphicDetails.dx
        this.DragMode.yAngolo = this.GraphicDetails.dy
        this.DrawMap()
      },

      OnMouseUp()
      { 
        window.addEventListener('pointermove', this.GetMousePos)
        window.addEventListener('pointermove', this.GetMousePosPlaceholder)
        let Trovato = false
        if (this.SpostamentoAbilitato)
        {
          for (let i = 0; i < this.PlaceholderMostrati.length; i++)
          {
            let Placeholder = this.PlaceholderMostrati[i]
            if (Placeholder.MouseInfoPlaceholder.MouseDown)
            {
              for (let j = 0; j < this.SitoSelezionato.DatiCatene.length; j++)
              {
                if(this.SitoSelezionato.DatiCatene[j].DatiCatena.CHIAVE == Placeholder.Chiave)
                  this.RegistraNuovaPosizioneCatena(this.SitoSelezionato.DatiCatene[j], Placeholder)
              }
              this.$refs.Canvas.removeEventListener('pointermove', this.DragComponentPlaceholder)            
              Placeholder.MouseInfoPlaceholder.MouseDown = false
              Trovato = true
              break
            }
          }
          if (!Trovato)
          {
            for (let i = 0; i < this.SitoSelezionato.DatiCatene.length; i++)
            {
              if (this.MostraGrafici)
              {
                if (this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDown || this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDownEnlarge)
                {
                  if (this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDownEnlarge)
                  {
                    this.RegistraNuovaDimensioneCatena(this.SitoSelezionato.DatiCatene[i])
                    this.$refs.Canvas.removeEventListener('pointermove', this.EnlargeComponent)            
                    Trovato = true
                    this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDownEnlarge = false
                    break
                  }
                  this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.xAngolo = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.x
                  this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.yAngolo = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.y


                  for (let j = 0; j < this.PlaceholderMostrati.length; j++)
                  {
                    if(this.SitoSelezionato.DatiCatene[i].DatiCatena.CHIAVE == this.PlaceholderMostrati[j].Chiave)
                      this.RegistraNuovaPosizioneCatena(this.SitoSelezionato.DatiCatene[i], this.PlaceholderMostrati[j])
                  }
                  this.$refs.Canvas.removeEventListener('pointermove', this.DragComponent)            
                  Trovato = true
                  this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDown = false
                  break
                }
              }
              else
              {
                if (this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDown)
                {
                  this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.xAngolo = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.x
                  this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.yAngolo = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.y
                  for (let j = 0; j < this.PlaceholderMostrati.length; j++)
                  {
                    if(this.SitoSelezionato.DatiCatene[i].DatiCatena.CHIAVE == this.PlaceholderMostrati[j].Chiave)
                      this.RegistraNuovaPosizioneCatena(this.SitoSelezionato.DatiCatene[i], this.PlaceholderMostrati[j])
                  }
                  this.$refs.Canvas.removeEventListener('pointermove', this.DragComponent)            
                  Trovato = true
                  this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDown = false
                  break
                }
              }
            }
          }
        }
        if (!Trovato)
        {
          this.DragMode.xAngolo = this.GraphicDetails.dx
          this.DragMode.yAngolo = this.GraphicDetails.dy
          this.$refs.Canvas.removeEventListener('pointermove', this.DragImage)
        }
        // let i = this.IndexCatena
        // if (i == -1)
        // {
        //   this.DragMode.xAngolo = this.GraphicDetails.dx
        //   this.DragMode.yAngolo = this.GraphicDetails.dy
        //   this.$refs.Canvas.removeEventListener('mousemove', this.DragImage)
        // }
        // else
        // {
        //   this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.xAngolo = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.x
        //   this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.yAngolo = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.y
        //   this.$refs.Canvas.removeEventListener('mousemove', this.DragComponent)
        // }
        this.ObjStyleCanvas = {cursor: 'auto'}
      },

      OnMouseDown(event)
      {
        window.removeEventListener('pointermove', this.GetMousePos)
        window.removeEventListener('pointermove', this.GetMousePosPlaceholder)
        let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
        let MouseX = event.clientX - Coords.left
        let MouseY = event.clientY - Coords.top
        let index = -1
        // this.IndexCatena = -1
        // let MouseDownComponente = false
        if (this.SpostamentoAbilitato)
        {
          for (let i = 0; i < this.PlaceholderMostrati.length; i++)
          {
            let Placeholder = this.PlaceholderMostrati[i]
            if (!Placeholder.FUORI_SERVIZIO)
            {
              // let PlaceholderDim = DIM_PLACEHOLDER
              let DimensioniPlaceholder = this.$refs.Placeholder
              let TopY    = Placeholder.MouseInfoPlaceholder.Coordinates.y
              let LeftX   = Placeholder.MouseInfoPlaceholder.Coordinates.x
              let BottomY = Placeholder.MouseInfoPlaceholder.Coordinates.y + DimensioniPlaceholder[i].clientHeight
              let RightX  = Placeholder.MouseInfoPlaceholder.Coordinates.x + DimensioniPlaceholder[i].clientWidth
              if (MouseX >= LeftX && MouseX <= RightX && MouseY >= TopY  && MouseY <= BottomY)
              {
                Placeholder.MouseInfoPlaceholder.MouseDown = true
                Placeholder.MouseInfoPlaceholder.Detail.xStart = MouseX
                Placeholder.MouseInfoPlaceholder.Detail.yStart = MouseY
                Placeholder.MouseInfoPlaceholder.Detail.xAngolo = MouseX
                Placeholder.MouseInfoPlaceholder.Detail.yAngolo = MouseY
                this.$refs.Canvas.addEventListener('pointermove', this.DragComponentPlaceholder)
                index = i
                break
              }
            }
          }
          if (index == -1)
          {
            for (let i = 0; i < this.SitoSelezionato.DatiCatene.length; i++)
            {
              if (!this.SitoSelezionato.DatiCatene[i].DatiCatena.FUORI_SERVIZIO)
              {
                if (this.MostraGrafici)
                {
                  let TopY = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.y
                  let LeftX = this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.x
                  let BottomY = TopY + this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.height
                  let RightX = LeftX + this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.width
                  let BottomYEnlarge = BottomY - 10
                  let RightXEnlarge = RightX - 10
                  if (MouseX >= LeftX && MouseX <= RightX &&
                      MouseY >= TopY  && MouseY <= BottomY)
                  {
                    if (MouseX >=  RightXEnlarge && MouseY >= BottomYEnlarge)
                    {
                      index = i
                      this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDownEnlarge = true
                      this.SitoSelezionato.DatiCatene[i].MouseInfo.Enlarge.xStart = LeftX
                      this.SitoSelezionato.DatiCatene[i].MouseInfo.Enlarge.yStart = TopY
                      this.$refs.Canvas.addEventListener('pointermove', this.EnlargeComponent)
                      break
                    }
                    index = i
                    this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDown = true
                    this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.xStart = MouseX
                    this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.yStart = MouseY
                    this.$refs.Canvas.addEventListener('pointermove', this.DragComponent)
                    break
                    // this.IndexCatena = i
                    // MouseDownComponente = true
                    // break
                  }
                }
                // else
                // {
                //   let PlaceholderDim = this.SitoSelezionato.DatiCatene[i].DatiGrafici.PLACEHOLDER_DIM
                //   let TopY = (this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.CenterCoords.y - PlaceholderDim / 2) + this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.y
                //   let LeftX = (this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.CenterCoords.x - PlaceholderDim / 2) + this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.x
                //   let BottomY = (this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.CenterCoords.y + PlaceholderDim / 2) + this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.y
                //   let RightX = (this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.CenterCoords.x + PlaceholderDim / 2) + this.SitoSelezionato.DatiCatene[i].MouseInfo.Coordinates.x
                //   if (MouseX >= LeftX && MouseX <= RightX &&
                //       MouseY >= TopY  && MouseY <= BottomY)
                //   {
                //     index = i
                //     this.SitoSelezionato.DatiCatene[i].MouseInfo.MouseDown = true
                //     this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.xStart = MouseX
                //     this.SitoSelezionato.DatiCatene[i].MouseInfo.Detail.yStart = MouseY
                //     this.$refs.Canvas.addEventListener('mousemove', this.DragComponent)
                //     break
                //   }
                // }
              }
            }
          }
        }
        if (index == -1)
        {
          this.DragMode.xStart = MouseX
          this.DragMode.yStart = MouseY
          this.$refs.Canvas.addEventListener('pointermove', this.DragImage)   
        }
        // if (!MouseDownComponente)
        // {
        //   this.DragMode.xStart = MouseX
        //   this.DragMode.yStart = MouseY
        //   this.$refs.Canvas.addEventListener('mousemove', this.DragImage)          
        // }
        // else
        // {
        //   this.SitoSelezionato.DatiCatene[this.IndexCatena].MouseInfo.Detail.xStart = MouseX
        //   this.SitoSelezionato.DatiCatene[this.IndexCatena].MouseInfo.Detail.yStart = MouseY
        //   this.$refs.Canvas.addEventListener('mousemove', this.DragComponent)
        // }
        this.ObjStyleCanvas = {cursor: 'grab'}
      },

      CalculateTitleStyle(Placeholder)
      {
        let FontSize                = Placeholder.TextSizeTitlePlaceholder + 'px'
        let FontColor               = Placeholder.ColorTitlePlaceholder

        let ObjStyle  = {
                          'font-weight'             : 'bold',
                          'height'                  : 25,
                          'fontSize'                : FontSize,
                          '-webkit-text-stroke'     : '1px bolt',
                          '-webkit-text-fill-color' : FontColor,
                          'text-align'              : 'center'
                        }

        if (Placeholder.PositionPlaceholder == POSIZIONI_TEXT_PLACEHOLDER.Destra)
          ObjStyle['align-self'] = 'flex-start'

        if (Placeholder.PositionPlaceholder == POSIZIONI_TEXT_PLACEHOLDER.Sinistra)
          ObjStyle['align-self'] = 'flex-end'
        
        return ObjStyle
      },

      CalculateAlarmStringStyle(Placeholder)
      {     
        let FontSize                = Placeholder.TextSizeTitlePlaceholder - 2 + 'px'   
        let FontColor               = Placeholder.ColorTitlePlaceholder
        return  {
                  'height'                  : 25,
                  'fontSize'                : FontSize,
                  '-webkit-text-fill-color' : FontColor,
                  'text-align'              : 'center'
                }
      },

      CalculateTitleContainerStyle(Placeholder, AlarmText = false)
      {
        let { x, y }                                          = Placeholder.MouseInfoPlaceholder.Coordinates
        let { PositionPlaceholder, TextSizeTitlePlaceholder } = Placeholder
        let QuantitaDaSottrarreAllaY                          = TextSizeTitlePlaceholder + 1

        let OggettoStile = {
                             'top'        : y - QuantitaDaSottrarreAllaY + 'px',
                             'left'       : x - 485 + 'px'
                           }

        if(PositionPlaceholder == POSIZIONI_TEXT_PLACEHOLDER.Sotto)
        {
          OggettoStile.top        = y - QuantitaDaSottrarreAllaY + 50 + 'px',
          OggettoStile.left       = x - 485 + 'px'
        }

        if(PositionPlaceholder == POSIZIONI_TEXT_PLACEHOLDER.Destra)
        {
          OggettoStile.top            = y - QuantitaDaSottrarreAllaY + 23 + 'px',
          OggettoStile.left           = x + Placeholder.MouseInfoPlaceholder.Detail.width + 5 + 'px'
        }

        if(PositionPlaceholder == POSIZIONI_TEXT_PLACEHOLDER.Sinistra)
        {
          OggettoStile.top            = y - QuantitaDaSottrarreAllaY + 23 + 'px',
          OggettoStile.left           = x - 1000 - 5 + 'px'     
        }

        if(AlarmText)
        {
          OggettoStile.top        = y + 50 + 'px',
          OggettoStile.left       = x - 485 + 'px'
        }

        return OggettoStile
      },

      RegistraNuovaPosizioneCatena(Catena, Placeholder)
      {
        Catena.DimensioniRelative.POS_X = ((Catena.MouseInfo.Coordinates.x - this.GraphicDetails.dx) / (this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom)).toFixed(5)
        Catena.DimensioniRelative.POS_Y = ((Catena.MouseInfo.Coordinates.y - this.GraphicDetails.dy) / (this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom)).toFixed(5)
                                        // LARGHEZZA : (Catena.MouseInfo.Detail.width / this.Immagine.width).toFixed(5),
                                        // ALTEZZA   : (Catena.MouseInfo.Detai.height / this.Immagine.height).toFixed(5)
        let ObjQuery = {Operazioni : []}
        let ObjCatena = {Query : 'UpdatePosizione', Parametri: {}}
        ObjCatena.Parametri = {
                                CHIAVE : Catena.DatiCatena.CHIAVE,
                                POS_X : TSchedaGenerica.PrepareForRecordDouble(Catena.DimensioniRelative.POS_X, 5),
                                POS_Y : TSchedaGenerica.PrepareForRecordDouble(Catena.DimensioniRelative.POS_Y, 5),
                                PLACEHOLDER_POS_X : TSchedaGenerica.PrepareForRecordDouble(Placeholder.CoordPlaceholderX, 5),
                                PLACEHOLDER_POS_Y : TSchedaGenerica.PrepareForRecordDouble(Placeholder.CoordPlaceholderY, 5)
                              }
        ObjQuery.Operazioni.push(ObjCatena)
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                          function()
                                                          { 
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          },
                                                          false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
      },

      RegistraNuovaDimensioneCatena(Catena)
      {
        Catena.DimensioniRelative.LARGHEZZA = (Catena.MouseInfo.Detail.width / (this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom)).toFixed(5)
        Catena.DimensioniRelative.ALTEZZA = (Catena.MouseInfo.Detail.height / (this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom)).toFixed(5)
                                        // LARGHEZZA : (Catena.MouseInfo.Detail.width / this.Immagine.width).toFixed(5),
                                        // ALTEZZA   : (Catena.MouseInfo.Detai.height / this.Immagine.height).toFixed(5)
        let ObjQuery = {Operazioni : []}
        let ObjCatena = {Query : 'UpdateDimensioni', Parametri: {}}
        ObjCatena.Parametri = {
                                CHIAVE : Catena.DatiCatena.CHIAVE,
                                LARGHEZZA : TSchedaGenerica.PrepareForRecordDouble(Catena.DimensioniRelative.LARGHEZZA, 5),
                                ALTEZZA : TSchedaGenerica.PrepareForRecordDouble(Catena.DimensioniRelative.ALTEZZA, 5)
                              }
        ObjQuery.Operazioni.push(ObjCatena)
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                          function()
                                                          { 
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          },
                                                          false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
      },

      DrawMap()
      {
        if (this.TempGraphicDetails != null)
        {
          this.GraphicDetails.dx = this.TempGraphicDetails.dx
          this.GraphicDetails.dy = this.TempGraphicDetails.dy
          this.GraphicDetails.Zoom = this.TempGraphicDetails.Zoom
          this.TempGraphicDetails = null
        }
        this.AdjZoom = Math.pow(this.GraphicDetails.Zoom, 3/4) - 0.4
        if (this.AdjZoom < 1)
          this.AdjZoom = 1
        // let RapportoZoomX = this.GraphicDetails.ZoomX / this.$refs.Canvas.width
        // let RapportoZoomY = this.GraphicDetails.ZoomY / this.$refs.Canvas.height
        let ZoomedWidth = this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom
        let ZoomedHeight = this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom
        //Calcolo zoom da cursore
        let LimitX = ZoomedWidth < this.$refs.Canvas.width ? ZoomedWidth : this.$refs.Canvas.width
        let LimitY = ZoomedHeight < this.$refs.Canvas.height ? ZoomedHeight : this.$refs.Canvas.height
        // this.GraphicDetails.dx = (this.GraphicDetails.dx * this.GraphicDetails.Zoom)
        // this.GraphicDetails.dy = (this.GraphicDetails.dy * this.GraphicDetails.Zoom)
        
        if (this.GraphicDetails.dx > 0)
          this.GraphicDetails.dx = 0
        if (this.GraphicDetails.dy > 0)
          this.GraphicDetails.dy = 0
        if (this.GraphicDetails.dx < this.$refs.Canvas.width - (ZoomedWidth))
          this.GraphicDetails.dx = LimitX - (ZoomedWidth)
        if (this.GraphicDetails.dy < this.$refs.Canvas.height - (ZoomedHeight))
          this.GraphicDetails.dy = LimitY - (ZoomedHeight)
       

        // this.GraphicDetails.dx = (this.GraphicDetails.dx * this.GraphicDetails.Zoom) - ((this.GraphicDetails.Zoom - 1) * this.GraphicDetails.ZoomX)
        // this.GraphicDetails.dy = (this.GraphicDetails.dy * this.GraphicDetails.Zoom) - ((this.GraphicDetails.Zoom - 1) * this.GraphicDetails.ZoomY)
        var Context = this.$refs.Canvas.getContext('2d')
        this.AssignDimensioniGraficiCatene()
        this.AssignDimensioniPlaceholder()
        Context.clearRect(0,0,this.$refs.Canvas.width,this.$refs.Canvas.height)
        Context.drawImage(this.Immagine, 
                          // Adjdx,
                          // Adjdy,
                          this.GraphicDetails.dx,
                          this.GraphicDetails.dy,
                          ZoomedWidth,
                          ZoomedHeight)
      },

      IsVerticalImage()
      {
        return this.Immagine.width < this.Immagine.height
      },

      CambiaMostraNascondiAllarmi()
      {
        if(!this.SlideAperti && !this.CambioSitoInCorso)
          this.EnableAlarmInfo = !this.EnableAlarmInfo
      },

      CambiaSpostamentoAbilitato()
      {
        if(!this.SlideAperti && !this.CambioSitoInCorso)
          this.SpostamentoAbilitato = !this.SpostamentoAbilitato
      },

      CambiaMostraNascondiGrafici()
      {
        if(!this.SlideAperti && !this.CambioSitoInCorso && !this.IsSitoMostraSoloMeteo)
          this.ToggleMostraGrafici()
      },

      CambiaTriggerAllineaPolari()
      {
        if(!this.SlideAperti && !this.CambioSitoInCorso)
          this.ToggleDataAllineamento()
      },

      CambiaTriggerAggiungiAbbinato()
      {
        if(!this.SlideAperti && !this.CambioSitoInCorso && this.MostraGrafici)
          this.ApriMenuGraficiAbbinati()
      },

      CambiaTriggerMenuCatene()
      {
        if(!this.SlideAperti && !this.CambioSitoInCorso)
          this.ApriMenuCatene()
      },

      AdattaAltriGrafici(Altezza, Larghezza)
      {
        let ObjQuery = {Operazioni : []}
        for (let i = 0; i < this.CateneMostrate.length; i++)
        { 
          let Catena = this.CateneMostrate[i]
          let OldAltezza = Catena.DimensioniRelative.ALTEZZA
          let OldLarghezza = Catena.DimensioniRelative.LARGHEZZA     
          Catena.DimensioniRelative.ALTEZZA = Altezza
          Catena.DimensioniRelative.LARGHEZZA = Larghezza
          Catena.DimensioniRelative.POS_X -= ((Larghezza - OldLarghezza) / 2)          
          Catena.DimensioniRelative.POS_Y -= ((Altezza - OldAltezza) / 2)
          let ObjCatena = {Query : 'AdattaDimensioni', Parametri: {}}
          ObjCatena.Parametri = {
                                  Chiave     : Catena.DatiCatena.CHIAVE,
                                  Altezza    : TSchedaGenerica.PrepareForRecordDouble(Altezza, 5),
                                  Larghezza  : TSchedaGenerica.PrepareForRecordDouble(Larghezza, 5),
                                  PosX       : TSchedaGenerica.PrepareForRecordDouble(Catena.DimensioniRelative.POS_X, 5),
                                  PosY       : TSchedaGenerica.PrepareForRecordDouble(Catena.DimensioniRelative.POS_Y, 5)
                                }
          ObjQuery.Operazioni.push(ObjCatena)
        } 
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, this.AssignDimensioniGraficiCatene,
                                                function(HTTPError,SubHTTPError,Response)
                                                {
                                                  SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                },
                                                false, {DMSEWSito: this.SitoSelezionato.CHIAVE})
      },

      CalculateCanvasDimensions()
      {
        this.$refs.Canvas.width  = this.$refs.CanvasContainer.clientWidth
        this.$refs.Canvas.height = this.$refs.CanvasContainer.clientHeight - 5
        this.AltezzaCanvas       = this.$refs.Canvas.height
        this.AltezzaPopupCatena  = this.$refs.Canvas.height * 0.6
        this.AltezzaDataTable    = this.AltezzaPopupCatena - 251
        this.CalculateStdImageArea()
      },

      CalculateStdImageArea()
      {
        let RapportoImmagine = this.Immagine.width / this.Immagine.height
        if (this.$refs.Canvas.width / RapportoImmagine > this.$refs.Canvas.height)
        {
          this.GraphicDetails.StdHeight = this.$refs.Canvas.height
          this.GraphicDetails.StdWidth  = this.$refs.Canvas.height * RapportoImmagine
        }
        else
        {
          this.GraphicDetails.StdWidth  = this.$refs.Canvas.width
          this.GraphicDetails.StdHeight = this.$refs.Canvas.width / RapportoImmagine
        }

        // Calcola lo zoom minimo necessario per coprire totalmente il canvas (cover)
        let minZoomCover = this.GetMinZoom()

        // Imposta lo zoom iniziale almeno al minimo calcolato (copre il canvas senza lasciare spazi bianchi)
        this.GraphicDetails.Zoom = minZoomCover

        // Centra l'immagine rispetto al canvas
        let ZoomedWidth = this.GraphicDetails.StdWidth * this.GraphicDetails.Zoom
        let ZoomedHeight = this.GraphicDetails.StdHeight * this.GraphicDetails.Zoom
        this.GraphicDetails.dx = (this.$refs.Canvas.width - ZoomedWidth) / 2
        this.GraphicDetails.dy = (this.$refs.Canvas.height - ZoomedHeight) / 2
      },

      GetMinZoom()
      {
        if (!this.$refs.Canvas || !this.GraphicDetails.StdWidth || !this.GraphicDetails.StdHeight)
          return 1

        let minZoomWidth  = this.$refs.Canvas.width  / this.GraphicDetails.StdWidth
        let minZoomHeight = this.$refs.Canvas.height / this.GraphicDetails.StdHeight
        let minZoom = Math.max(1, minZoomWidth, minZoomHeight)

        return minZoom > MAX_ZOOM ? MAX_ZOOM : minZoom
      },

      ResizeCanvas()
      {
        setTimeout(() => { this.CalculateCanvasDimensions(); this.DrawMap() }, 1)
      },

      GetMousePosPlaceholder(event)
      {
        let Coords                = this.$refs.CanvasContainer.getBoundingClientRect()
        let XPos                  = event.clientX - Coords.left
        let YPos                  = event.clientY - Coords.top
        let DimensioniPlaceholder = this.$refs.Placeholder
        let Trovato = false
        for (let i = 0; i < this.PlaceholderMostrati.length; i++)
        {
          let MouseInfoPlaceholder = this.PlaceholderMostrati[i].MouseInfoPlaceholder
          this.PlaceholderMostrati[i].MouseOverOnCoords = {IsMouseOver: false, x: 0, y: 0}
          if (MouseInfoPlaceholder.Coordinates.x + DimensioniPlaceholder[i].clientWidth / 2  <= XPos && MouseInfoPlaceholder.Coordinates.x + MouseInfoPlaceholder.Detail.radius + DimensioniPlaceholder[i].clientWidth / 2 >= XPos &&
              MouseInfoPlaceholder.Coordinates.y - DimensioniPlaceholder[i].clientHeight <= YPos && MouseInfoPlaceholder.Coordinates.y + MouseInfoPlaceholder.Detail.radius - DimensioniPlaceholder[i].clientHeight >= YPos && 
              !Trovato)
          // if (MouseInfoPlaceholder.Coordinates.x<= XPos && MouseInfoPlaceholder.Coordinates.x + MouseInfoPlaceholder.Detail.radius  >= XPos &&
          //     MouseInfoPlaceholder.Coordinates.y <= YPos && MouseInfoPlaceholder.Coordinates.y + MouseInfoPlaceholder.Detail.radius  >= YPos && 
          //     !Trovato)
          {
            this.PlaceholderMostrati[i].MouseOverOnCoords = {IsMouseOver: true, x: XPos, y: YPos} 
            Trovato = true
          }
        }
      },

      GetMousePos(event)
      {
        let Coords = this.$refs.CanvasContainer.getBoundingClientRect()
        let XPos = event.clientX - Coords.left
        let YPos = event.clientY - Coords.top
        let Trovato = false
        for (let i = 0; i < this.CateneMostrate.length; i++)
        {
          let MouseInfo = this.CateneMostrate[i].MouseInfo
          this.CateneMostrate[i].MouseOverOnCoords = {IsMouseOver: false, x: 0, y: 0}
          if (MouseInfo.Coordinates.x <= XPos && MouseInfo.Coordinates.x + MouseInfo.Detail.width >= XPos &&
              MouseInfo.Coordinates.y <= YPos && MouseInfo.Coordinates.y + MouseInfo.Detail.height >= YPos && !Trovato)
          {
            this.CateneMostrate[i].MouseOverOnCoords = {IsMouseOver: true, x: XPos, y: YPos} 
            Trovato = true
          }
        }
      },

      GetStileIcona(Raggio)
      {
        const PixelTraslazione = - (Raggio * 1.87 - 22) + 'px';
        return {transform: 'translateY(' + PixelTraslazione + ')'};
      },

      AllarmiVisibili(CfgCatena,AllarmiAttivi)
      {
        for(const Allarme of AllarmiAttivi) 
        {
          if(CfgCatena[Allarme.TIPO] === true)
          {
            return true;
          }
          if(Allarme.TIPO === 'Accelerometro')
          {
            const MaxValore = Math.max(...Allarme.ListaModuli.map(Modulo => Math.abs(Modulo.VALORE)));
            if(MaxValore > Math.abs(CfgCatena.Accelerometro))
            {
              return true;
            }
          }
        }
        return false;
      }

    },
    computed:
    {
      TriggerMostraNascondiAllarmi:
      {
        get()
        {
          return this.MenuTrigger.TriggerMostraNascondiAllarmi 
        }
      },

      TriggerAbilitaSpostamento:
      {
        get()
        {
          return this.MenuTrigger.TriggerAbilitaSpostamento 
        }
      },

      TriggerMenuCatene:
      {
        get()
        {
          return this.MenuTrigger.TriggerMenuCatene 
        }
      },
      
      TriggerAllineaPolari:
      {
        get()
        {
          return this.MenuTrigger.TriggerAllineaPolari 
        }
      },
      
      TriggerAggiungiAbbinato:
      {
        get()
        {
          return this.MenuTrigger.TriggerAggiungiAbbinato 
        }
      },
      
      TriggerMostraGrafici:
      {
        get()
        {
          return this.MenuTrigger.TriggerMostraGrafici 
        }
      },

      CateneMostrate:
      {
        get()
        {
          if (this.SitoSelezionato.DatiCatene != undefined)
          {
            return this.SitoSelezionato.DatiCatene.filter((element) => {return !element.DatiCatena.FUORI_SERVIZIO})
          }
          return []
        }
      },

      PlaceholderMostrati:
      {
        get()
        {
          if (this.PlaceholderArray != undefined)
            return this.PlaceholderArray.filter((element) => {return !element.FUORI_SERVIZIO})

          return []
        }
      },

      Piezometri:
      {
        get()
        {
          var Result = []
          
          for(let i = 0; i < this.CatenaSelezionata.DataTable.Righe.length; i++)
          {
            if(this.CatenaSelezionata.DataTable.Righe[i].Dati.PIEZOMETRO.Valore)
              Result.push(i)
          }
          return Result;
        }
      },

      SlideAperti:
      {
        get()
        {
          return this.MenuCateneAperto || this.MenuGraficiAbbinatiAperto
        }
      },

      // GraficiMostrati:
      // {
      //   get()
      //   {
      //     if (this.ListaGrafici.Mostra != undefined)
      //     {
      //       return this.ListaGrafici.filter((element) => (element.Mostra))
      //     }
      //     return []
      //   }
      // }
    },
    watch:
    {
      TriggerMostraNascondiAllarmi:
      {
        handler()
        {
          this.CambiaMostraNascondiAllarmi()
        },
        deep : true
      },

      TriggerAbilitaSpostamento:
      {
        handler()
        {
          this.CambiaSpostamentoAbilitato()
        },
        deep : true
      },

      TriggerMenuCatene:
      {
        handler()
        {
          this.CambiaTriggerMenuCatene()
        },
        deep : true
      },
      
      TriggerAggiungiAbbinato:
      {
        handler()
        {
          this.CambiaTriggerAggiungiAbbinato()
        },
        deep : true
      },
      
      TriggerAllineaPolari:
      {
        handler(NewValue)
        {
          if(NewValue != 0)
            this.CambiaTriggerAllineaPolari()
        },
        deep : true
      },
      
      TriggerMostraGrafici:
      {
        handler()
        {
          this.CambiaMostraNascondiGrafici()
        },
        deep : true
      },

      IndexCatena:
      {
        handler(NewValue)
        {
          if (NewValue != -1)
          {
            this.CatenaSelezionata = new TCatena(NewValue, this.SitoSelezionato.CHIAVE, undefined, this.GetTraduzioneLabel, this.LinguaUtente)
          }
        }
      },
      
      ListaGrafici:
      {
        handler()
        {
          this.GraficiChange++
        },
        deep : true 
      },

      Contatore:
      {
        handler(NewValue)
        {
          if (NewValue % this.TickIntervallo == 0)
          {
            this.MostraIconaAllarme = !this.MostraIconaAllarme
            // if (this.IndiceAllarmeMostrato + 1 == this.CatenaInfo.TipiAllarmiAttivi.length)
            //   this.IndiceAllarmeMostrato = 0
            // else
            //   this.IndiceAllarmeMostrato++
          }
        }
      }
    },
    beforeMount() 
    {     
      TemporaryGlobals.TmpNumber = -1
      this.Admin = SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore
      this.MostraGrafici = this.Admin
      window.addEventListener('resize', this.ResizeCanvas)
      this.Timer = setInterval(() => (this.Contatore++), SystemInformation.Configurazione.TICK_DURATION)
    },

    mounted()
    {
      localStorage.removeItem(LOCALSTORAGE.GraficiAbbinatiAllineati)
      this.CaricamentoDatiSiti = true
      let ChiaveSito = -1
      let Parametri = TZGenericFunct.GetURLParameters()
      if ('ChiaveSito' in Parametri)
      {
        ChiaveSito = Parametri.ChiaveSito
      }

      this.MenuTrigger.TriggerMostraGrafici         = 0
      this.MenuTrigger.TriggerAllineaPolari         = 0
      this.MenuTrigger.TriggerMostraNascondiAllarmi = 0
      this.MenuTrigger.TriggerAbilitaSpostamento    = 0

      window.addEventListener('pointermove', this.GetMousePos)
      let Self = this
      this.LoadAllSite(function()
      {
        if(Self.ListaSiti.length != 0)
        {
          let index = Self.ListaSiti.findIndex((element) => {return element.CHIAVE == ChiaveSito})
          if (index == -1)
            index = 0          
          Self.LoadSite(Self.ListaSiti[index])
        }
        else Self.CaricamentoDatiSiti = false
      })
    },

    unmounted()
    {
      window.removeEventListener('resize', this.ResizeCanvas)
      window.removeEventListener('pointermove', this.GetMousePos)
      window.removeEventListener('pointermove', this.GetMousePosPlaceholder)
      clearInterval(this.Timer)
    }
}
</script>
<style>
.Flex {
  display: flex;
}

#PopupDatiGeneraliCatena #ModalBody {
  overflow-y: hidden !important;
}
</style>